// source: securitiesreferencedata.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var fix_pb = require('./fix_pb.js');
goog.object.extend(proto, fix_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
var session_pb = require('./session_pb.js');
goog.object.extend(proto, session_pb);
goog.exportSymbol('proto.SecuritiesReferenceData.AdjustmentEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.CorporateActionEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.DerivativeSecurityList', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.DerivativeSecurityListRequest', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.DerivativeSecurityListRequest.TradingSessionIdUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.DerivativeSecurityListRequest.TradingSessionSubIdUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.ExpirationCycleEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.FinancialStatusEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.HaltReasonEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.LegSettlTypeEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.LegSwapTypeEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.ListUpdateActionEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.MDBookTypeEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.ProductEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.RelSymDerivSecGrp', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecListGrp', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecLstUpdRelSymGrp', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecTypesGrp', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityDefinition', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityDefinitionRequest', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityDefinitionRequest.TradingSessionIdUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityDefinitionRequest.TradingSessionSubIdUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityList', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityList.SecurityListTypeSourceUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityList.SecurityListTypeUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityListRequest', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityListRequest.SecurityListTypeSourceUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityListRequest.SecurityListTypeUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityListRequest.TradingSessionIdUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityListRequest.TradingSessionSubIdUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityListRequestTypeEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityListTypeEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityListTypeSourceEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityListUpdateReport', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityListUpdateReport.SecurityListTypeSourceUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityListUpdateReport.SecurityListTypeUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityRequestResultEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityRequestTypeEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityResponseTypeEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityStatus', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityStatus.HaltReasonUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityStatus.SecurityTradingEventUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityStatus.SecurityTradingStatusUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityStatus.TradingSessionIdUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityStatus.TradingSessionSubIdUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityStatusRequest', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityStatusRequest.TradingSessionIdUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityStatusRequest.TradingSessionSubIdUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityTradingEventEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityTradingStatusEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityTypeEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityTypeRequest', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityTypeRequest.TradingSessionIdUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityTypeRequest.TradingSessionSubIdUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityTypes', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityTypes.TradingSessionIdUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityTypes.TradingSessionSubIdUnionCase', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SecurityUpdateActionEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.TradingSessionIDEnum', null, global);
goog.exportSymbol('proto.SecuritiesReferenceData.TradingSessionSubIDEnum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SecuritiesReferenceData.RelSymDerivSecGrp.repeatedFields_, null);
};
goog.inherits(proto.SecuritiesReferenceData.RelSymDerivSecGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SecuritiesReferenceData.RelSymDerivSecGrp.displayName = 'proto.SecuritiesReferenceData.RelSymDerivSecGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SecuritiesReferenceData.SecListGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SecuritiesReferenceData.SecListGrp.repeatedFields_, null);
};
goog.inherits(proto.SecuritiesReferenceData.SecListGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SecuritiesReferenceData.SecListGrp.displayName = 'proto.SecuritiesReferenceData.SecListGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SecuritiesReferenceData.SecTypesGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.SecuritiesReferenceData.SecTypesGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SecuritiesReferenceData.SecTypesGrp.displayName = 'proto.SecuritiesReferenceData.SecTypesGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.repeatedFields_, null);
};
goog.inherits(proto.SecuritiesReferenceData.SecLstUpdRelSymGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.displayName = 'proto.SecuritiesReferenceData.SecLstUpdRelSymGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.repeatedFields_, null);
};
goog.inherits(proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.displayName = 'proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SecuritiesReferenceData.SecurityDefinitionRequest.repeatedFields_, proto.SecuritiesReferenceData.SecurityDefinitionRequest.oneofGroups_);
};
goog.inherits(proto.SecuritiesReferenceData.SecurityDefinitionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SecuritiesReferenceData.SecurityDefinitionRequest.displayName = 'proto.SecuritiesReferenceData.SecurityDefinitionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SecuritiesReferenceData.SecurityDefinition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SecuritiesReferenceData.SecurityDefinition.repeatedFields_, null);
};
goog.inherits(proto.SecuritiesReferenceData.SecurityDefinition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SecuritiesReferenceData.SecurityDefinition.displayName = 'proto.SecuritiesReferenceData.SecurityDefinition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SecuritiesReferenceData.SecurityStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SecuritiesReferenceData.SecurityStatusRequest.repeatedFields_, proto.SecuritiesReferenceData.SecurityStatusRequest.oneofGroups_);
};
goog.inherits(proto.SecuritiesReferenceData.SecurityStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SecuritiesReferenceData.SecurityStatusRequest.displayName = 'proto.SecuritiesReferenceData.SecurityStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SecuritiesReferenceData.SecurityStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SecuritiesReferenceData.SecurityStatus.repeatedFields_, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_);
};
goog.inherits(proto.SecuritiesReferenceData.SecurityStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SecuritiesReferenceData.SecurityStatus.displayName = 'proto.SecuritiesReferenceData.SecurityStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SecuritiesReferenceData.SecurityTypeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.SecuritiesReferenceData.SecurityTypeRequest.oneofGroups_);
};
goog.inherits(proto.SecuritiesReferenceData.SecurityTypeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SecuritiesReferenceData.SecurityTypeRequest.displayName = 'proto.SecuritiesReferenceData.SecurityTypeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SecuritiesReferenceData.SecurityTypes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SecuritiesReferenceData.SecurityTypes.repeatedFields_, proto.SecuritiesReferenceData.SecurityTypes.oneofGroups_);
};
goog.inherits(proto.SecuritiesReferenceData.SecurityTypes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SecuritiesReferenceData.SecurityTypes.displayName = 'proto.SecuritiesReferenceData.SecurityTypes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SecuritiesReferenceData.SecurityListRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SecuritiesReferenceData.SecurityListRequest.repeatedFields_, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_);
};
goog.inherits(proto.SecuritiesReferenceData.SecurityListRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SecuritiesReferenceData.SecurityListRequest.displayName = 'proto.SecuritiesReferenceData.SecurityListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SecuritiesReferenceData.SecurityList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SecuritiesReferenceData.SecurityList.repeatedFields_, proto.SecuritiesReferenceData.SecurityList.oneofGroups_);
};
goog.inherits(proto.SecuritiesReferenceData.SecurityList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SecuritiesReferenceData.SecurityList.displayName = 'proto.SecuritiesReferenceData.SecurityList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.SecuritiesReferenceData.DerivativeSecurityListRequest.oneofGroups_);
};
goog.inherits(proto.SecuritiesReferenceData.DerivativeSecurityListRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SecuritiesReferenceData.DerivativeSecurityListRequest.displayName = 'proto.SecuritiesReferenceData.DerivativeSecurityListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SecuritiesReferenceData.DerivativeSecurityList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SecuritiesReferenceData.DerivativeSecurityList.repeatedFields_, null);
};
goog.inherits(proto.SecuritiesReferenceData.DerivativeSecurityList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SecuritiesReferenceData.DerivativeSecurityList.displayName = 'proto.SecuritiesReferenceData.DerivativeSecurityList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.repeatedFields_, null);
};
goog.inherits(proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.displayName = 'proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SecuritiesReferenceData.SecurityListUpdateReport.repeatedFields_, proto.SecuritiesReferenceData.SecurityListUpdateReport.oneofGroups_);
};
goog.inherits(proto.SecuritiesReferenceData.SecurityListUpdateReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SecuritiesReferenceData.SecurityListUpdateReport.displayName = 'proto.SecuritiesReferenceData.SecurityListUpdateReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.repeatedFields_, null);
};
goog.inherits(proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.displayName = 'proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.repeatedFields_ = [4,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.SecuritiesReferenceData.RelSymDerivSecGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    currency: jspb.Message.getFieldWithDefault(msg, 1, ""),
    encodedText: jspb.Message.getFieldWithDefault(msg, 2, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 3, 0),
    instrmtLegGrpList: jspb.Message.toObjectList(msg.getInstrmtLegGrpList(),
    common_pb.InstrmtLegGrp.toObject, includeInstance),
    instrument: (f = msg.getInstrument()) && common_pb.Instrument.toObject(includeInstance, f),
    instrumentExtension: (f = msg.getInstrumentExtension()) && common_pb.InstrumentExtension.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 7, ""),
    corporateActionList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    secondaryPriceLimits: (f = msg.getSecondaryPriceLimits()) && common_pb.SecondaryPriceLimits.toObject(includeInstance, f),
    relSymTransactTime: (f = msg.getRelSymTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SecuritiesReferenceData.RelSymDerivSecGrp;
  return proto.SecuritiesReferenceData.RelSymDerivSecGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 4:
      var value = new common_pb.InstrmtLegGrp;
      reader.readMessage(value,common_pb.InstrmtLegGrp.deserializeBinaryFromReader);
      msg.addInstrmtLegGrp(value);
      break;
    case 5:
      var value = new common_pb.Instrument;
      reader.readMessage(value,common_pb.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 6:
      var value = new common_pb.InstrumentExtension;
      reader.readMessage(value,common_pb.InstrumentExtension.deserializeBinaryFromReader);
      msg.setInstrumentExtension(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 8:
      var values = /** @type {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addCorporateAction(values[i]);
      }
      break;
    case 9:
      var value = new common_pb.SecondaryPriceLimits;
      reader.readMessage(value,common_pb.SecondaryPriceLimits.deserializeBinaryFromReader);
      msg.setSecondaryPriceLimits(value);
      break;
    case 10:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRelSymTransactTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SecuritiesReferenceData.RelSymDerivSecGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      3,
      f
    );
  }
  f = message.getInstrmtLegGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      common_pb.InstrmtLegGrp.serializeBinaryToWriter
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Instrument.serializeBinaryToWriter
    );
  }
  f = message.getInstrumentExtension();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      common_pb.InstrumentExtension.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCorporateActionList();
  if (f.length > 0) {
    writer.writePackedEnum(
      8,
      f
    );
  }
  f = message.getSecondaryPriceLimits();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      common_pb.SecondaryPriceLimits.serializeBinaryToWriter
    );
  }
  f = message.getRelSymTransactTime();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string currency = 1;
 * @return {string}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} returns this
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string encoded_text = 2;
 * @return {string}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} returns this
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional sfixed64 encoded_text_len = 3;
 * @return {number}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} returns this
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated Common.InstrmtLegGrp instrmt_leg_grp = 4;
 * @return {!Array<!proto.Common.InstrmtLegGrp>}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.getInstrmtLegGrpList = function() {
  return /** @type{!Array<!proto.Common.InstrmtLegGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.InstrmtLegGrp, 4));
};


/**
 * @param {!Array<!proto.Common.InstrmtLegGrp>} value
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} returns this
*/
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.setInstrmtLegGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Common.InstrmtLegGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.InstrmtLegGrp}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.addInstrmtLegGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Common.InstrmtLegGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} returns this
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.clearInstrmtLegGrpList = function() {
  return this.setInstrmtLegGrpList([]);
};


/**
 * optional Common.Instrument instrument = 5;
 * @return {?proto.Common.Instrument}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, common_pb.Instrument, 5));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} returns this
*/
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} returns this
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Common.InstrumentExtension instrument_extension = 6;
 * @return {?proto.Common.InstrumentExtension}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.getInstrumentExtension = function() {
  return /** @type{?proto.Common.InstrumentExtension} */ (
    jspb.Message.getWrapperField(this, common_pb.InstrumentExtension, 6));
};


/**
 * @param {?proto.Common.InstrumentExtension|undefined} value
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} returns this
*/
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.setInstrumentExtension = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} returns this
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.clearInstrumentExtension = function() {
  return this.setInstrumentExtension(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.hasInstrumentExtension = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string text = 7;
 * @return {string}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} returns this
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated CorporateActionEnum corporate_action = 8;
 * @return {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.getCorporateActionList = function() {
  return /** @type {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>} value
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} returns this
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.setCorporateActionList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {!proto.SecuritiesReferenceData.CorporateActionEnum} value
 * @param {number=} opt_index
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} returns this
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.addCorporateAction = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} returns this
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.clearCorporateActionList = function() {
  return this.setCorporateActionList([]);
};


/**
 * optional Common.SecondaryPriceLimits secondary_price_limits = 9;
 * @return {?proto.Common.SecondaryPriceLimits}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.getSecondaryPriceLimits = function() {
  return /** @type{?proto.Common.SecondaryPriceLimits} */ (
    jspb.Message.getWrapperField(this, common_pb.SecondaryPriceLimits, 9));
};


/**
 * @param {?proto.Common.SecondaryPriceLimits|undefined} value
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} returns this
*/
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.setSecondaryPriceLimits = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} returns this
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.clearSecondaryPriceLimits = function() {
  return this.setSecondaryPriceLimits(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.hasSecondaryPriceLimits = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional fix.Timestamp rel_sym_transact_time = 10;
 * @return {?proto.fix.Timestamp}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.getRelSymTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 10));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} returns this
*/
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.setRelSymTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp} returns this
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.clearRelSymTransactTime = function() {
  return this.setRelSymTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.RelSymDerivSecGrp.prototype.hasRelSymTransactTime = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SecuritiesReferenceData.SecListGrp.repeatedFields_ = [5,9,11,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.SecuritiesReferenceData.SecListGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SecuritiesReferenceData.SecListGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecListGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    currency: jspb.Message.getFieldWithDefault(msg, 1, ""),
    encodedText: jspb.Message.getFieldWithDefault(msg, 2, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 3, 0),
    financingDetails: (f = msg.getFinancingDetails()) && common_pb.FinancingDetails.toObject(includeInstance, f),
    instrmtLegSecListGrpList: jspb.Message.toObjectList(msg.getInstrmtLegSecListGrpList(),
    common_pb.InstrmtLegSecListGrp.toObject, includeInstance),
    instrument: (f = msg.getInstrument()) && common_pb.Instrument.toObject(includeInstance, f),
    instrumentExtension: (f = msg.getInstrumentExtension()) && common_pb.InstrumentExtension.toObject(includeInstance, f),
    spreadOrBenchmarkCurveData: (f = msg.getSpreadOrBenchmarkCurveData()) && common_pb.SpreadOrBenchmarkCurveData.toObject(includeInstance, f),
    stipulationsList: jspb.Message.toObjectList(msg.getStipulationsList(),
    common_pb.Stipulations.toObject, includeInstance),
    text: jspb.Message.getFieldWithDefault(msg, 10, ""),
    undInstrmtGrpList: jspb.Message.toObjectList(msg.getUndInstrmtGrpList(),
    common_pb.UndInstrmtGrp.toObject, includeInstance),
    yieldData: (f = msg.getYieldData()) && common_pb.YieldData.toObject(includeInstance, f),
    securityTradingRules: (f = msg.getSecurityTradingRules()) && common_pb.SecurityTradingRules.toObject(includeInstance, f),
    strikeRulesList: jspb.Message.toObjectList(msg.getStrikeRulesList(),
    common_pb.StrikeRules.toObject, includeInstance),
    relSymTransactTime: (f = msg.getRelSymTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SecuritiesReferenceData.SecListGrp}
 */
proto.SecuritiesReferenceData.SecListGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SecuritiesReferenceData.SecListGrp;
  return proto.SecuritiesReferenceData.SecListGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SecuritiesReferenceData.SecListGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SecuritiesReferenceData.SecListGrp}
 */
proto.SecuritiesReferenceData.SecListGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 4:
      var value = new common_pb.FinancingDetails;
      reader.readMessage(value,common_pb.FinancingDetails.deserializeBinaryFromReader);
      msg.setFinancingDetails(value);
      break;
    case 5:
      var value = new common_pb.InstrmtLegSecListGrp;
      reader.readMessage(value,common_pb.InstrmtLegSecListGrp.deserializeBinaryFromReader);
      msg.addInstrmtLegSecListGrp(value);
      break;
    case 6:
      var value = new common_pb.Instrument;
      reader.readMessage(value,common_pb.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 7:
      var value = new common_pb.InstrumentExtension;
      reader.readMessage(value,common_pb.InstrumentExtension.deserializeBinaryFromReader);
      msg.setInstrumentExtension(value);
      break;
    case 8:
      var value = new common_pb.SpreadOrBenchmarkCurveData;
      reader.readMessage(value,common_pb.SpreadOrBenchmarkCurveData.deserializeBinaryFromReader);
      msg.setSpreadOrBenchmarkCurveData(value);
      break;
    case 9:
      var value = new common_pb.Stipulations;
      reader.readMessage(value,common_pb.Stipulations.deserializeBinaryFromReader);
      msg.addStipulations(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 11:
      var value = new common_pb.UndInstrmtGrp;
      reader.readMessage(value,common_pb.UndInstrmtGrp.deserializeBinaryFromReader);
      msg.addUndInstrmtGrp(value);
      break;
    case 12:
      var value = new common_pb.YieldData;
      reader.readMessage(value,common_pb.YieldData.deserializeBinaryFromReader);
      msg.setYieldData(value);
      break;
    case 13:
      var value = new common_pb.SecurityTradingRules;
      reader.readMessage(value,common_pb.SecurityTradingRules.deserializeBinaryFromReader);
      msg.setSecurityTradingRules(value);
      break;
    case 14:
      var value = new common_pb.StrikeRules;
      reader.readMessage(value,common_pb.StrikeRules.deserializeBinaryFromReader);
      msg.addStrikeRules(value);
      break;
    case 15:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRelSymTransactTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SecuritiesReferenceData.SecListGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SecuritiesReferenceData.SecListGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecListGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      3,
      f
    );
  }
  f = message.getFinancingDetails();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.FinancingDetails.serializeBinaryToWriter
    );
  }
  f = message.getInstrmtLegSecListGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      common_pb.InstrmtLegSecListGrp.serializeBinaryToWriter
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      common_pb.Instrument.serializeBinaryToWriter
    );
  }
  f = message.getInstrumentExtension();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      common_pb.InstrumentExtension.serializeBinaryToWriter
    );
  }
  f = message.getSpreadOrBenchmarkCurveData();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      common_pb.SpreadOrBenchmarkCurveData.serializeBinaryToWriter
    );
  }
  f = message.getStipulationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      common_pb.Stipulations.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getUndInstrmtGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      common_pb.UndInstrmtGrp.serializeBinaryToWriter
    );
  }
  f = message.getYieldData();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      common_pb.YieldData.serializeBinaryToWriter
    );
  }
  f = message.getSecurityTradingRules();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      common_pb.SecurityTradingRules.serializeBinaryToWriter
    );
  }
  f = message.getStrikeRulesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      common_pb.StrikeRules.serializeBinaryToWriter
    );
  }
  f = message.getRelSymTransactTime();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string currency = 1;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string encoded_text = 2;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional sfixed64 encoded_text_len = 3;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional Common.FinancingDetails financing_details = 4;
 * @return {?proto.Common.FinancingDetails}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.getFinancingDetails = function() {
  return /** @type{?proto.Common.FinancingDetails} */ (
    jspb.Message.getWrapperField(this, common_pb.FinancingDetails, 4));
};


/**
 * @param {?proto.Common.FinancingDetails|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
*/
proto.SecuritiesReferenceData.SecListGrp.prototype.setFinancingDetails = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.clearFinancingDetails = function() {
  return this.setFinancingDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.hasFinancingDetails = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated Common.InstrmtLegSecListGrp instrmt_leg_sec_list_grp = 5;
 * @return {!Array<!proto.Common.InstrmtLegSecListGrp>}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.getInstrmtLegSecListGrpList = function() {
  return /** @type{!Array<!proto.Common.InstrmtLegSecListGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.InstrmtLegSecListGrp, 5));
};


/**
 * @param {!Array<!proto.Common.InstrmtLegSecListGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
*/
proto.SecuritiesReferenceData.SecListGrp.prototype.setInstrmtLegSecListGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.Common.InstrmtLegSecListGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.InstrmtLegSecListGrp}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.addInstrmtLegSecListGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.Common.InstrmtLegSecListGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.clearInstrmtLegSecListGrpList = function() {
  return this.setInstrmtLegSecListGrpList([]);
};


/**
 * optional Common.Instrument instrument = 6;
 * @return {?proto.Common.Instrument}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, common_pb.Instrument, 6));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
*/
proto.SecuritiesReferenceData.SecListGrp.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Common.InstrumentExtension instrument_extension = 7;
 * @return {?proto.Common.InstrumentExtension}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.getInstrumentExtension = function() {
  return /** @type{?proto.Common.InstrumentExtension} */ (
    jspb.Message.getWrapperField(this, common_pb.InstrumentExtension, 7));
};


/**
 * @param {?proto.Common.InstrumentExtension|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
*/
proto.SecuritiesReferenceData.SecListGrp.prototype.setInstrumentExtension = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.clearInstrumentExtension = function() {
  return this.setInstrumentExtension(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.hasInstrumentExtension = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Common.SpreadOrBenchmarkCurveData spread_or_benchmark_curve_data = 8;
 * @return {?proto.Common.SpreadOrBenchmarkCurveData}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.getSpreadOrBenchmarkCurveData = function() {
  return /** @type{?proto.Common.SpreadOrBenchmarkCurveData} */ (
    jspb.Message.getWrapperField(this, common_pb.SpreadOrBenchmarkCurveData, 8));
};


/**
 * @param {?proto.Common.SpreadOrBenchmarkCurveData|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
*/
proto.SecuritiesReferenceData.SecListGrp.prototype.setSpreadOrBenchmarkCurveData = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.clearSpreadOrBenchmarkCurveData = function() {
  return this.setSpreadOrBenchmarkCurveData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.hasSpreadOrBenchmarkCurveData = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated Common.Stipulations stipulations = 9;
 * @return {!Array<!proto.Common.Stipulations>}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.getStipulationsList = function() {
  return /** @type{!Array<!proto.Common.Stipulations>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Stipulations, 9));
};


/**
 * @param {!Array<!proto.Common.Stipulations>} value
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
*/
proto.SecuritiesReferenceData.SecListGrp.prototype.setStipulationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.Common.Stipulations=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.Stipulations}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.addStipulations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.Common.Stipulations, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.clearStipulationsList = function() {
  return this.setStipulationsList([]);
};


/**
 * optional string text = 10;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * repeated Common.UndInstrmtGrp und_instrmt_grp = 11;
 * @return {!Array<!proto.Common.UndInstrmtGrp>}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.getUndInstrmtGrpList = function() {
  return /** @type{!Array<!proto.Common.UndInstrmtGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.UndInstrmtGrp, 11));
};


/**
 * @param {!Array<!proto.Common.UndInstrmtGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
*/
proto.SecuritiesReferenceData.SecListGrp.prototype.setUndInstrmtGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.Common.UndInstrmtGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndInstrmtGrp}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.addUndInstrmtGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.Common.UndInstrmtGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.clearUndInstrmtGrpList = function() {
  return this.setUndInstrmtGrpList([]);
};


/**
 * optional Common.YieldData yield_data = 12;
 * @return {?proto.Common.YieldData}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.getYieldData = function() {
  return /** @type{?proto.Common.YieldData} */ (
    jspb.Message.getWrapperField(this, common_pb.YieldData, 12));
};


/**
 * @param {?proto.Common.YieldData|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
*/
proto.SecuritiesReferenceData.SecListGrp.prototype.setYieldData = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.clearYieldData = function() {
  return this.setYieldData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.hasYieldData = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional Common.SecurityTradingRules security_trading_rules = 13;
 * @return {?proto.Common.SecurityTradingRules}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.getSecurityTradingRules = function() {
  return /** @type{?proto.Common.SecurityTradingRules} */ (
    jspb.Message.getWrapperField(this, common_pb.SecurityTradingRules, 13));
};


/**
 * @param {?proto.Common.SecurityTradingRules|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
*/
proto.SecuritiesReferenceData.SecListGrp.prototype.setSecurityTradingRules = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.clearSecurityTradingRules = function() {
  return this.setSecurityTradingRules(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.hasSecurityTradingRules = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * repeated Common.StrikeRules strike_rules = 14;
 * @return {!Array<!proto.Common.StrikeRules>}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.getStrikeRulesList = function() {
  return /** @type{!Array<!proto.Common.StrikeRules>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.StrikeRules, 14));
};


/**
 * @param {!Array<!proto.Common.StrikeRules>} value
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
*/
proto.SecuritiesReferenceData.SecListGrp.prototype.setStrikeRulesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.Common.StrikeRules=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.StrikeRules}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.addStrikeRules = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.Common.StrikeRules, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.clearStrikeRulesList = function() {
  return this.setStrikeRulesList([]);
};


/**
 * optional fix.Timestamp rel_sym_transact_time = 15;
 * @return {?proto.fix.Timestamp}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.getRelSymTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 15));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
*/
proto.SecuritiesReferenceData.SecListGrp.prototype.setRelSymTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecListGrp} returns this
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.clearRelSymTransactTime = function() {
  return this.setRelSymTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecListGrp.prototype.hasRelSymTransactTime = function() {
  return jspb.Message.getField(this, 15) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SecuritiesReferenceData.SecTypesGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.SecuritiesReferenceData.SecTypesGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SecuritiesReferenceData.SecTypesGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecTypesGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    cfiCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    product: jspb.Message.getFieldWithDefault(msg, 2, 0),
    securitySubType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    securityType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    transactTime: (f = msg.getTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SecuritiesReferenceData.SecTypesGrp}
 */
proto.SecuritiesReferenceData.SecTypesGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SecuritiesReferenceData.SecTypesGrp;
  return proto.SecuritiesReferenceData.SecTypesGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SecuritiesReferenceData.SecTypesGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SecuritiesReferenceData.SecTypesGrp}
 */
proto.SecuritiesReferenceData.SecTypesGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCfiCode(value);
      break;
    case 2:
      var value = /** @type {!proto.SecuritiesReferenceData.ProductEnum} */ (reader.readEnum());
      msg.setProduct(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecuritySubType(value);
      break;
    case 4:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityTypeEnum} */ (reader.readEnum());
      msg.setSecurityType(value);
      break;
    case 5:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SecuritiesReferenceData.SecTypesGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SecuritiesReferenceData.SecTypesGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SecuritiesReferenceData.SecTypesGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecTypesGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCfiCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProduct();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSecuritySubType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSecurityType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTransactTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string cfi_code = 1;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecTypesGrp.prototype.getCfiCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecTypesGrp} returns this
 */
proto.SecuritiesReferenceData.SecTypesGrp.prototype.setCfiCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ProductEnum product = 2;
 * @return {!proto.SecuritiesReferenceData.ProductEnum}
 */
proto.SecuritiesReferenceData.SecTypesGrp.prototype.getProduct = function() {
  return /** @type {!proto.SecuritiesReferenceData.ProductEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.ProductEnum} value
 * @return {!proto.SecuritiesReferenceData.SecTypesGrp} returns this
 */
proto.SecuritiesReferenceData.SecTypesGrp.prototype.setProduct = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string security_sub_type = 3;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecTypesGrp.prototype.getSecuritySubType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecTypesGrp} returns this
 */
proto.SecuritiesReferenceData.SecTypesGrp.prototype.setSecuritySubType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional SecurityTypeEnum security_type = 4;
 * @return {!proto.SecuritiesReferenceData.SecurityTypeEnum}
 */
proto.SecuritiesReferenceData.SecTypesGrp.prototype.getSecurityType = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.SecTypesGrp} returns this
 */
proto.SecuritiesReferenceData.SecTypesGrp.prototype.setSecurityType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional fix.Timestamp transact_time = 5;
 * @return {?proto.fix.Timestamp}
 */
proto.SecuritiesReferenceData.SecTypesGrp.prototype.getTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 5));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecTypesGrp} returns this
*/
proto.SecuritiesReferenceData.SecTypesGrp.prototype.setTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecTypesGrp} returns this
 */
proto.SecuritiesReferenceData.SecTypesGrp.prototype.clearTransactTime = function() {
  return this.setTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecTypesGrp.prototype.hasTransactTime = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.repeatedFields_ = [7,9,14,15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    currency: jspb.Message.getFieldWithDefault(msg, 1, ""),
    encodedText: jspb.Message.getFieldWithDefault(msg, 2, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 3, 0),
    financingDetails: (f = msg.getFinancingDetails()) && common_pb.FinancingDetails.toObject(includeInstance, f),
    instrument: (f = msg.getInstrument()) && common_pb.Instrument.toObject(includeInstance, f),
    instrumentExtension: (f = msg.getInstrumentExtension()) && common_pb.InstrumentExtension.toObject(includeInstance, f),
    secLstUpdRelSymsLegGrpList: jspb.Message.toObjectList(msg.getSecLstUpdRelSymsLegGrpList(),
    proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.toObject, includeInstance),
    spreadOrBenchmarkCurveData: (f = msg.getSpreadOrBenchmarkCurveData()) && common_pb.SpreadOrBenchmarkCurveData.toObject(includeInstance, f),
    stipulationsList: jspb.Message.toObjectList(msg.getStipulationsList(),
    common_pb.Stipulations.toObject, includeInstance),
    text: jspb.Message.getFieldWithDefault(msg, 10, ""),
    yieldData: (f = msg.getYieldData()) && common_pb.YieldData.toObject(includeInstance, f),
    listUpdateAction: jspb.Message.getFieldWithDefault(msg, 12, 0),
    securityTradingRules: (f = msg.getSecurityTradingRules()) && common_pb.SecurityTradingRules.toObject(includeInstance, f),
    strikeRulesList: jspb.Message.toObjectList(msg.getStrikeRulesList(),
    common_pb.StrikeRules.toObject, includeInstance),
    undInstrmtGrpList: jspb.Message.toObjectList(msg.getUndInstrmtGrpList(),
    common_pb.UndInstrmtGrp.toObject, includeInstance),
    relSymTransactTime: (f = msg.getRelSymTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SecuritiesReferenceData.SecLstUpdRelSymGrp;
  return proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 4:
      var value = new common_pb.FinancingDetails;
      reader.readMessage(value,common_pb.FinancingDetails.deserializeBinaryFromReader);
      msg.setFinancingDetails(value);
      break;
    case 5:
      var value = new common_pb.Instrument;
      reader.readMessage(value,common_pb.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 6:
      var value = new common_pb.InstrumentExtension;
      reader.readMessage(value,common_pb.InstrumentExtension.deserializeBinaryFromReader);
      msg.setInstrumentExtension(value);
      break;
    case 7:
      var value = new proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp;
      reader.readMessage(value,proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.deserializeBinaryFromReader);
      msg.addSecLstUpdRelSymsLegGrp(value);
      break;
    case 8:
      var value = new common_pb.SpreadOrBenchmarkCurveData;
      reader.readMessage(value,common_pb.SpreadOrBenchmarkCurveData.deserializeBinaryFromReader);
      msg.setSpreadOrBenchmarkCurveData(value);
      break;
    case 9:
      var value = new common_pb.Stipulations;
      reader.readMessage(value,common_pb.Stipulations.deserializeBinaryFromReader);
      msg.addStipulations(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 11:
      var value = new common_pb.YieldData;
      reader.readMessage(value,common_pb.YieldData.deserializeBinaryFromReader);
      msg.setYieldData(value);
      break;
    case 12:
      var value = /** @type {!proto.SecuritiesReferenceData.ListUpdateActionEnum} */ (reader.readEnum());
      msg.setListUpdateAction(value);
      break;
    case 13:
      var value = new common_pb.SecurityTradingRules;
      reader.readMessage(value,common_pb.SecurityTradingRules.deserializeBinaryFromReader);
      msg.setSecurityTradingRules(value);
      break;
    case 14:
      var value = new common_pb.StrikeRules;
      reader.readMessage(value,common_pb.StrikeRules.deserializeBinaryFromReader);
      msg.addStrikeRules(value);
      break;
    case 15:
      var value = new common_pb.UndInstrmtGrp;
      reader.readMessage(value,common_pb.UndInstrmtGrp.deserializeBinaryFromReader);
      msg.addUndInstrmtGrp(value);
      break;
    case 16:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRelSymTransactTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      3,
      f
    );
  }
  f = message.getFinancingDetails();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.FinancingDetails.serializeBinaryToWriter
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Instrument.serializeBinaryToWriter
    );
  }
  f = message.getInstrumentExtension();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      common_pb.InstrumentExtension.serializeBinaryToWriter
    );
  }
  f = message.getSecLstUpdRelSymsLegGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.serializeBinaryToWriter
    );
  }
  f = message.getSpreadOrBenchmarkCurveData();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      common_pb.SpreadOrBenchmarkCurveData.serializeBinaryToWriter
    );
  }
  f = message.getStipulationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      common_pb.Stipulations.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getYieldData();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      common_pb.YieldData.serializeBinaryToWriter
    );
  }
  f = message.getListUpdateAction();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getSecurityTradingRules();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      common_pb.SecurityTradingRules.serializeBinaryToWriter
    );
  }
  f = message.getStrikeRulesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      common_pb.StrikeRules.serializeBinaryToWriter
    );
  }
  f = message.getUndInstrmtGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      15,
      f,
      common_pb.UndInstrmtGrp.serializeBinaryToWriter
    );
  }
  f = message.getRelSymTransactTime();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string currency = 1;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string encoded_text = 2;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional sfixed64 encoded_text_len = 3;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional Common.FinancingDetails financing_details = 4;
 * @return {?proto.Common.FinancingDetails}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.getFinancingDetails = function() {
  return /** @type{?proto.Common.FinancingDetails} */ (
    jspb.Message.getWrapperField(this, common_pb.FinancingDetails, 4));
};


/**
 * @param {?proto.Common.FinancingDetails|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
*/
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.setFinancingDetails = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.clearFinancingDetails = function() {
  return this.setFinancingDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.hasFinancingDetails = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Common.Instrument instrument = 5;
 * @return {?proto.Common.Instrument}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, common_pb.Instrument, 5));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
*/
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Common.InstrumentExtension instrument_extension = 6;
 * @return {?proto.Common.InstrumentExtension}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.getInstrumentExtension = function() {
  return /** @type{?proto.Common.InstrumentExtension} */ (
    jspb.Message.getWrapperField(this, common_pb.InstrumentExtension, 6));
};


/**
 * @param {?proto.Common.InstrumentExtension|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
*/
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.setInstrumentExtension = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.clearInstrumentExtension = function() {
  return this.setInstrumentExtension(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.hasInstrumentExtension = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated SecLstUpdRelSymsLegGrp sec_lst_upd_rel_syms_leg_grp = 7;
 * @return {!Array<!proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp>}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.getSecLstUpdRelSymsLegGrpList = function() {
  return /** @type{!Array<!proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp, 7));
};


/**
 * @param {!Array<!proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
*/
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.setSecLstUpdRelSymsLegGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.addSecLstUpdRelSymsLegGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.clearSecLstUpdRelSymsLegGrpList = function() {
  return this.setSecLstUpdRelSymsLegGrpList([]);
};


/**
 * optional Common.SpreadOrBenchmarkCurveData spread_or_benchmark_curve_data = 8;
 * @return {?proto.Common.SpreadOrBenchmarkCurveData}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.getSpreadOrBenchmarkCurveData = function() {
  return /** @type{?proto.Common.SpreadOrBenchmarkCurveData} */ (
    jspb.Message.getWrapperField(this, common_pb.SpreadOrBenchmarkCurveData, 8));
};


/**
 * @param {?proto.Common.SpreadOrBenchmarkCurveData|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
*/
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.setSpreadOrBenchmarkCurveData = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.clearSpreadOrBenchmarkCurveData = function() {
  return this.setSpreadOrBenchmarkCurveData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.hasSpreadOrBenchmarkCurveData = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated Common.Stipulations stipulations = 9;
 * @return {!Array<!proto.Common.Stipulations>}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.getStipulationsList = function() {
  return /** @type{!Array<!proto.Common.Stipulations>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Stipulations, 9));
};


/**
 * @param {!Array<!proto.Common.Stipulations>} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
*/
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.setStipulationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.Common.Stipulations=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.Stipulations}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.addStipulations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.Common.Stipulations, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.clearStipulationsList = function() {
  return this.setStipulationsList([]);
};


/**
 * optional string text = 10;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional Common.YieldData yield_data = 11;
 * @return {?proto.Common.YieldData}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.getYieldData = function() {
  return /** @type{?proto.Common.YieldData} */ (
    jspb.Message.getWrapperField(this, common_pb.YieldData, 11));
};


/**
 * @param {?proto.Common.YieldData|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
*/
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.setYieldData = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.clearYieldData = function() {
  return this.setYieldData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.hasYieldData = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional ListUpdateActionEnum list_update_action = 12;
 * @return {!proto.SecuritiesReferenceData.ListUpdateActionEnum}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.getListUpdateAction = function() {
  return /** @type {!proto.SecuritiesReferenceData.ListUpdateActionEnum} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.ListUpdateActionEnum} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.setListUpdateAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional Common.SecurityTradingRules security_trading_rules = 13;
 * @return {?proto.Common.SecurityTradingRules}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.getSecurityTradingRules = function() {
  return /** @type{?proto.Common.SecurityTradingRules} */ (
    jspb.Message.getWrapperField(this, common_pb.SecurityTradingRules, 13));
};


/**
 * @param {?proto.Common.SecurityTradingRules|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
*/
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.setSecurityTradingRules = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.clearSecurityTradingRules = function() {
  return this.setSecurityTradingRules(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.hasSecurityTradingRules = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * repeated Common.StrikeRules strike_rules = 14;
 * @return {!Array<!proto.Common.StrikeRules>}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.getStrikeRulesList = function() {
  return /** @type{!Array<!proto.Common.StrikeRules>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.StrikeRules, 14));
};


/**
 * @param {!Array<!proto.Common.StrikeRules>} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
*/
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.setStrikeRulesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.Common.StrikeRules=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.StrikeRules}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.addStrikeRules = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.Common.StrikeRules, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.clearStrikeRulesList = function() {
  return this.setStrikeRulesList([]);
};


/**
 * repeated Common.UndInstrmtGrp und_instrmt_grp = 15;
 * @return {!Array<!proto.Common.UndInstrmtGrp>}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.getUndInstrmtGrpList = function() {
  return /** @type{!Array<!proto.Common.UndInstrmtGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.UndInstrmtGrp, 15));
};


/**
 * @param {!Array<!proto.Common.UndInstrmtGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
*/
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.setUndInstrmtGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 15, value);
};


/**
 * @param {!proto.Common.UndInstrmtGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndInstrmtGrp}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.addUndInstrmtGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.Common.UndInstrmtGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.clearUndInstrmtGrpList = function() {
  return this.setUndInstrmtGrpList([]);
};


/**
 * optional fix.Timestamp rel_sym_transact_time = 16;
 * @return {?proto.fix.Timestamp}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.getRelSymTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 16));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
*/
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.setRelSymTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.clearRelSymTransactTime = function() {
  return this.setRelSymTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.prototype.hasRelSymTransactTime = function() {
  return jspb.Message.getField(this, 16) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    instrumentLeg: (f = msg.getInstrumentLeg()) && common_pb.InstrumentLeg.toObject(includeInstance, f),
    legBenchmarkCurveData: (f = msg.getLegBenchmarkCurveData()) && common_pb.LegBenchmarkCurveData.toObject(includeInstance, f),
    legSettlType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    legStipulationsList: jspb.Message.toObjectList(msg.getLegStipulationsList(),
    common_pb.LegStipulations.toObject, includeInstance),
    legSwapType: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp;
  return proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.InstrumentLeg;
      reader.readMessage(value,common_pb.InstrumentLeg.deserializeBinaryFromReader);
      msg.setInstrumentLeg(value);
      break;
    case 2:
      var value = new common_pb.LegBenchmarkCurveData;
      reader.readMessage(value,common_pb.LegBenchmarkCurveData.deserializeBinaryFromReader);
      msg.setLegBenchmarkCurveData(value);
      break;
    case 3:
      var value = /** @type {!proto.SecuritiesReferenceData.LegSettlTypeEnum} */ (reader.readEnum());
      msg.setLegSettlType(value);
      break;
    case 4:
      var value = new common_pb.LegStipulations;
      reader.readMessage(value,common_pb.LegStipulations.deserializeBinaryFromReader);
      msg.addLegStipulations(value);
      break;
    case 5:
      var value = /** @type {!proto.SecuritiesReferenceData.LegSwapTypeEnum} */ (reader.readEnum());
      msg.setLegSwapType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstrumentLeg();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.InstrumentLeg.serializeBinaryToWriter
    );
  }
  f = message.getLegBenchmarkCurveData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.LegBenchmarkCurveData.serializeBinaryToWriter
    );
  }
  f = message.getLegSettlType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getLegStipulationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      common_pb.LegStipulations.serializeBinaryToWriter
    );
  }
  f = message.getLegSwapType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional Common.InstrumentLeg instrument_leg = 1;
 * @return {?proto.Common.InstrumentLeg}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.prototype.getInstrumentLeg = function() {
  return /** @type{?proto.Common.InstrumentLeg} */ (
    jspb.Message.getWrapperField(this, common_pb.InstrumentLeg, 1));
};


/**
 * @param {?proto.Common.InstrumentLeg|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp} returns this
*/
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.prototype.setInstrumentLeg = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.prototype.clearInstrumentLeg = function() {
  return this.setInstrumentLeg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.prototype.hasInstrumentLeg = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Common.LegBenchmarkCurveData leg_benchmark_curve_data = 2;
 * @return {?proto.Common.LegBenchmarkCurveData}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.prototype.getLegBenchmarkCurveData = function() {
  return /** @type{?proto.Common.LegBenchmarkCurveData} */ (
    jspb.Message.getWrapperField(this, common_pb.LegBenchmarkCurveData, 2));
};


/**
 * @param {?proto.Common.LegBenchmarkCurveData|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp} returns this
*/
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.prototype.setLegBenchmarkCurveData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.prototype.clearLegBenchmarkCurveData = function() {
  return this.setLegBenchmarkCurveData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.prototype.hasLegBenchmarkCurveData = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional LegSettlTypeEnum leg_settl_type = 3;
 * @return {!proto.SecuritiesReferenceData.LegSettlTypeEnum}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.prototype.getLegSettlType = function() {
  return /** @type {!proto.SecuritiesReferenceData.LegSettlTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.LegSettlTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.prototype.setLegSettlType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated Common.LegStipulations leg_stipulations = 4;
 * @return {!Array<!proto.Common.LegStipulations>}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.prototype.getLegStipulationsList = function() {
  return /** @type{!Array<!proto.Common.LegStipulations>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.LegStipulations, 4));
};


/**
 * @param {!Array<!proto.Common.LegStipulations>} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp} returns this
*/
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.prototype.setLegStipulationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Common.LegStipulations=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.LegStipulations}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.prototype.addLegStipulations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Common.LegStipulations, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.prototype.clearLegStipulationsList = function() {
  return this.setLegStipulationsList([]);
};


/**
 * optional LegSwapTypeEnum leg_swap_type = 5;
 * @return {!proto.SecuritiesReferenceData.LegSwapTypeEnum}
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.prototype.getLegSwapType = function() {
  return /** @type {!proto.SecuritiesReferenceData.LegSwapTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.LegSwapTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp} returns this
 */
proto.SecuritiesReferenceData.SecLstUpdRelSymsLegGrp.prototype.setLegSwapType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.repeatedFields_ = [16,18,22];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.oneofGroups_ = [[9,10],[13,14]];

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.TradingSessionIdUnionCase = {
  TRADING_SESSION_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_ID: 9,
  TRADING_SESSION_ID_RESERVED100PLUS: 10
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityDefinitionRequest.TradingSessionIdUnionCase}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getTradingSessionIdUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityDefinitionRequest.TradingSessionIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityDefinitionRequest.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.TradingSessionSubIdUnionCase = {
  TRADING_SESSION_SUB_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_SUB_ID: 13,
  TRADING_SESSION_SUB_ID_RESERVED100PLUS: 14
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityDefinitionRequest.TradingSessionSubIdUnionCase}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getTradingSessionSubIdUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityDefinitionRequest.TradingSessionSubIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityDefinitionRequest.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.SecuritiesReferenceData.SecurityDefinitionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    currency: jspb.Message.getFieldWithDefault(msg, 1, ""),
    encodedText: jspb.Message.getFieldWithDefault(msg, 2, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 3, 0),
    securityReqId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    securityRequestType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 8, ""),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 9, 0),
    tradingSessionIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 10, 0),
    instrument: (f = msg.getInstrument()) && common_pb.Instrument.toObject(includeInstance, f),
    subscriptionRequestType: jspb.Message.getFieldWithDefault(msg, 12, 0),
    tradingSessionSubId: jspb.Message.getFieldWithDefault(msg, 13, 0),
    tradingSessionSubIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 14, 0),
    expirationCycle: jspb.Message.getFieldWithDefault(msg, 15, 0),
    instrmtLegGrpList: jspb.Message.toObjectList(msg.getInstrmtLegGrpList(),
    common_pb.InstrmtLegGrp.toObject, includeInstance),
    instrumentExtension: (f = msg.getInstrumentExtension()) && common_pb.InstrumentExtension.toObject(includeInstance, f),
    undInstrmtGrpList: jspb.Message.toObjectList(msg.getUndInstrmtGrpList(),
    common_pb.UndInstrmtGrp.toObject, includeInstance),
    marketId: jspb.Message.getFieldWithDefault(msg, 19, ""),
    marketSegmentId: jspb.Message.getFieldWithDefault(msg, 20, ""),
    spreadOrBenchmarkCurveData: (f = msg.getSpreadOrBenchmarkCurveData()) && common_pb.SpreadOrBenchmarkCurveData.toObject(includeInstance, f),
    stipulationsList: jspb.Message.toObjectList(msg.getStipulationsList(),
    common_pb.Stipulations.toObject, includeInstance),
    yieldData: (f = msg.getYieldData()) && common_pb.YieldData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SecuritiesReferenceData.SecurityDefinitionRequest;
  return proto.SecuritiesReferenceData.SecurityDefinitionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityReqId(value);
      break;
    case 5:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityRequestTypeEnum} */ (reader.readEnum());
      msg.setSecurityRequestType(value);
      break;
    case 6:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 7:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 9:
      var value = /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionIdReserved100plus(value);
      break;
    case 11:
      var value = new common_pb.Instrument;
      reader.readMessage(value,common_pb.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 12:
      var value = /** @type {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum} */ (reader.readEnum());
      msg.setSubscriptionRequestType(value);
      break;
    case 13:
      var value = /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (reader.readEnum());
      msg.setTradingSessionSubId(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionSubIdReserved100plus(value);
      break;
    case 15:
      var value = /** @type {!proto.SecuritiesReferenceData.ExpirationCycleEnum} */ (reader.readEnum());
      msg.setExpirationCycle(value);
      break;
    case 16:
      var value = new common_pb.InstrmtLegGrp;
      reader.readMessage(value,common_pb.InstrmtLegGrp.deserializeBinaryFromReader);
      msg.addInstrmtLegGrp(value);
      break;
    case 17:
      var value = new common_pb.InstrumentExtension;
      reader.readMessage(value,common_pb.InstrumentExtension.deserializeBinaryFromReader);
      msg.setInstrumentExtension(value);
      break;
    case 18:
      var value = new common_pb.UndInstrmtGrp;
      reader.readMessage(value,common_pb.UndInstrmtGrp.deserializeBinaryFromReader);
      msg.addUndInstrmtGrp(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketSegmentId(value);
      break;
    case 21:
      var value = new common_pb.SpreadOrBenchmarkCurveData;
      reader.readMessage(value,common_pb.SpreadOrBenchmarkCurveData.deserializeBinaryFromReader);
      msg.setSpreadOrBenchmarkCurveData(value);
      break;
    case 22:
      var value = new common_pb.Stipulations;
      reader.readMessage(value,common_pb.Stipulations.deserializeBinaryFromReader);
      msg.addStipulations(value);
      break;
    case 23:
      var value = new common_pb.YieldData;
      reader.readMessage(value,common_pb.YieldData.deserializeBinaryFromReader);
      msg.setYieldData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SecuritiesReferenceData.SecurityDefinitionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      3,
      f
    );
  }
  f = message.getSecurityReqId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSecurityRequestType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeFixed32(
      10,
      f
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      common_pb.Instrument.serializeBinaryToWriter
    );
  }
  f = message.getSubscriptionRequestType();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeFixed32(
      14,
      f
    );
  }
  f = message.getExpirationCycle();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getInstrmtLegGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      common_pb.InstrmtLegGrp.serializeBinaryToWriter
    );
  }
  f = message.getInstrumentExtension();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      common_pb.InstrumentExtension.serializeBinaryToWriter
    );
  }
  f = message.getUndInstrmtGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      common_pb.UndInstrmtGrp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getMarketSegmentId();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getSpreadOrBenchmarkCurveData();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      common_pb.SpreadOrBenchmarkCurveData.serializeBinaryToWriter
    );
  }
  f = message.getStipulationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      22,
      f,
      common_pb.Stipulations.serializeBinaryToWriter
    );
  }
  f = message.getYieldData();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      common_pb.YieldData.serializeBinaryToWriter
    );
  }
};


/**
 * optional string currency = 1;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string encoded_text = 2;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional sfixed64 encoded_text_len = 3;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string security_req_id = 4;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getSecurityReqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setSecurityReqId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional SecurityRequestTypeEnum security_request_type = 5;
 * @return {!proto.SecuritiesReferenceData.SecurityRequestTypeEnum}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getSecurityRequestType = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityRequestTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityRequestTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setSecurityRequestType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional Session.StandardHeader standard_header = 6;
 * @return {?proto.Session.StandardHeader}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 6));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 7;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 7));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string text = 8;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional TradingSessionIDEnum trading_session_id = 9;
 * @return {!proto.SecuritiesReferenceData.TradingSessionIDEnum}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getTradingSessionId = function() {
  return /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.TradingSessionIDEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setOneofField(this, 9, proto.SecuritiesReferenceData.SecurityDefinitionRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.clearTradingSessionId = function() {
  return jspb.Message.setOneofField(this, 9, proto.SecuritiesReferenceData.SecurityDefinitionRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.hasTradingSessionId = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional fixed32 trading_session_id_reserved100plus = 10;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getTradingSessionIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setTradingSessionIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 10, proto.SecuritiesReferenceData.SecurityDefinitionRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.clearTradingSessionIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 10, proto.SecuritiesReferenceData.SecurityDefinitionRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.hasTradingSessionIdReserved100plus = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional Common.Instrument instrument = 11;
 * @return {?proto.Common.Instrument}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, common_pb.Instrument, 11));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional SubscriptionRequestTypeEnum subscription_request_type = 12;
 * @return {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getSubscriptionRequestType = function() {
  return /** @type {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setSubscriptionRequestType = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional TradingSessionSubIDEnum trading_session_sub_id = 13;
 * @return {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getTradingSessionSubId = function() {
  return /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setTradingSessionSubId = function(value) {
  return jspb.Message.setOneofField(this, 13, proto.SecuritiesReferenceData.SecurityDefinitionRequest.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.clearTradingSessionSubId = function() {
  return jspb.Message.setOneofField(this, 13, proto.SecuritiesReferenceData.SecurityDefinitionRequest.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.hasTradingSessionSubId = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional fixed32 trading_session_sub_id_reserved100plus = 14;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getTradingSessionSubIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setTradingSessionSubIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 14, proto.SecuritiesReferenceData.SecurityDefinitionRequest.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.clearTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 14, proto.SecuritiesReferenceData.SecurityDefinitionRequest.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.hasTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional ExpirationCycleEnum expiration_cycle = 15;
 * @return {!proto.SecuritiesReferenceData.ExpirationCycleEnum}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getExpirationCycle = function() {
  return /** @type {!proto.SecuritiesReferenceData.ExpirationCycleEnum} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.ExpirationCycleEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setExpirationCycle = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * repeated Common.InstrmtLegGrp instrmt_leg_grp = 16;
 * @return {!Array<!proto.Common.InstrmtLegGrp>}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getInstrmtLegGrpList = function() {
  return /** @type{!Array<!proto.Common.InstrmtLegGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.InstrmtLegGrp, 16));
};


/**
 * @param {!Array<!proto.Common.InstrmtLegGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setInstrmtLegGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.Common.InstrmtLegGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.InstrmtLegGrp}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.addInstrmtLegGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.Common.InstrmtLegGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.clearInstrmtLegGrpList = function() {
  return this.setInstrmtLegGrpList([]);
};


/**
 * optional Common.InstrumentExtension instrument_extension = 17;
 * @return {?proto.Common.InstrumentExtension}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getInstrumentExtension = function() {
  return /** @type{?proto.Common.InstrumentExtension} */ (
    jspb.Message.getWrapperField(this, common_pb.InstrumentExtension, 17));
};


/**
 * @param {?proto.Common.InstrumentExtension|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setInstrumentExtension = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.clearInstrumentExtension = function() {
  return this.setInstrumentExtension(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.hasInstrumentExtension = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * repeated Common.UndInstrmtGrp und_instrmt_grp = 18;
 * @return {!Array<!proto.Common.UndInstrmtGrp>}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getUndInstrmtGrpList = function() {
  return /** @type{!Array<!proto.Common.UndInstrmtGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.UndInstrmtGrp, 18));
};


/**
 * @param {!Array<!proto.Common.UndInstrmtGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setUndInstrmtGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.Common.UndInstrmtGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndInstrmtGrp}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.addUndInstrmtGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.Common.UndInstrmtGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.clearUndInstrmtGrpList = function() {
  return this.setUndInstrmtGrpList([]);
};


/**
 * optional string market_id = 19;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string market_segment_id = 20;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getMarketSegmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setMarketSegmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional Common.SpreadOrBenchmarkCurveData spread_or_benchmark_curve_data = 21;
 * @return {?proto.Common.SpreadOrBenchmarkCurveData}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getSpreadOrBenchmarkCurveData = function() {
  return /** @type{?proto.Common.SpreadOrBenchmarkCurveData} */ (
    jspb.Message.getWrapperField(this, common_pb.SpreadOrBenchmarkCurveData, 21));
};


/**
 * @param {?proto.Common.SpreadOrBenchmarkCurveData|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setSpreadOrBenchmarkCurveData = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.clearSpreadOrBenchmarkCurveData = function() {
  return this.setSpreadOrBenchmarkCurveData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.hasSpreadOrBenchmarkCurveData = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * repeated Common.Stipulations stipulations = 22;
 * @return {!Array<!proto.Common.Stipulations>}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getStipulationsList = function() {
  return /** @type{!Array<!proto.Common.Stipulations>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Stipulations, 22));
};


/**
 * @param {!Array<!proto.Common.Stipulations>} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setStipulationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 22, value);
};


/**
 * @param {!proto.Common.Stipulations=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.Stipulations}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.addStipulations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 22, opt_value, proto.Common.Stipulations, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.clearStipulationsList = function() {
  return this.setStipulationsList([]);
};


/**
 * optional Common.YieldData yield_data = 23;
 * @return {?proto.Common.YieldData}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.getYieldData = function() {
  return /** @type{?proto.Common.YieldData} */ (
    jspb.Message.getWrapperField(this, common_pb.YieldData, 23));
};


/**
 * @param {?proto.Common.YieldData|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.setYieldData = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.clearYieldData = function() {
  return this.setYieldData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinitionRequest.prototype.hasYieldData = function() {
  return jspb.Message.getField(this, 23) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SecuritiesReferenceData.SecurityDefinition.repeatedFields_ = [12,15,17,18,20];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.toObject = function(opt_includeInstance) {
  return proto.SecuritiesReferenceData.SecurityDefinition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SecuritiesReferenceData.SecurityDefinition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityDefinition.toObject = function(includeInstance, msg) {
  var f, obj = {
    currency: jspb.Message.getFieldWithDefault(msg, 1, ""),
    encodedText: jspb.Message.getFieldWithDefault(msg, 2, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 3, 0),
    securityReqId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    securityResponseId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    securityResponseType: jspb.Message.getFieldWithDefault(msg, 6, 0),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 9, ""),
    instrument: (f = msg.getInstrument()) && common_pb.Instrument.toObject(includeInstance, f),
    clearingBusinessDate: jspb.Message.getFieldWithDefault(msg, 11, 0),
    instrmtLegGrpList: jspb.Message.toObjectList(msg.getInstrmtLegGrpList(),
    common_pb.InstrmtLegGrp.toObject, includeInstance),
    instrumentExtension: (f = msg.getInstrumentExtension()) && common_pb.InstrumentExtension.toObject(includeInstance, f),
    securityReportId: jspb.Message.getFieldWithDefault(msg, 14, 0),
    undInstrmtGrpList: jspb.Message.toObjectList(msg.getUndInstrmtGrpList(),
    common_pb.UndInstrmtGrp.toObject, includeInstance),
    applicationSequenceControl: (f = msg.getApplicationSequenceControl()) && common_pb.ApplicationSequenceControl.toObject(includeInstance, f),
    corporateActionList: (f = jspb.Message.getRepeatedField(msg, 17)) == null ? undefined : f,
    marketSegmentGrpList: jspb.Message.toObjectList(msg.getMarketSegmentGrpList(),
    common_pb.MarketSegmentGrp.toObject, includeInstance),
    spreadOrBenchmarkCurveData: (f = msg.getSpreadOrBenchmarkCurveData()) && common_pb.SpreadOrBenchmarkCurveData.toObject(includeInstance, f),
    stipulationsList: jspb.Message.toObjectList(msg.getStipulationsList(),
    common_pb.Stipulations.toObject, includeInstance),
    yieldData: (f = msg.getYieldData()) && common_pb.YieldData.toObject(includeInstance, f),
    transactTime: (f = msg.getTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition}
 */
proto.SecuritiesReferenceData.SecurityDefinition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SecuritiesReferenceData.SecurityDefinition;
  return proto.SecuritiesReferenceData.SecurityDefinition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SecuritiesReferenceData.SecurityDefinition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition}
 */
proto.SecuritiesReferenceData.SecurityDefinition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityReqId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityResponseId(value);
      break;
    case 6:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityResponseTypeEnum} */ (reader.readEnum());
      msg.setSecurityResponseType(value);
      break;
    case 7:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 8:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 10:
      var value = new common_pb.Instrument;
      reader.readMessage(value,common_pb.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setClearingBusinessDate(value);
      break;
    case 12:
      var value = new common_pb.InstrmtLegGrp;
      reader.readMessage(value,common_pb.InstrmtLegGrp.deserializeBinaryFromReader);
      msg.addInstrmtLegGrp(value);
      break;
    case 13:
      var value = new common_pb.InstrumentExtension;
      reader.readMessage(value,common_pb.InstrumentExtension.deserializeBinaryFromReader);
      msg.setInstrumentExtension(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setSecurityReportId(value);
      break;
    case 15:
      var value = new common_pb.UndInstrmtGrp;
      reader.readMessage(value,common_pb.UndInstrmtGrp.deserializeBinaryFromReader);
      msg.addUndInstrmtGrp(value);
      break;
    case 16:
      var value = new common_pb.ApplicationSequenceControl;
      reader.readMessage(value,common_pb.ApplicationSequenceControl.deserializeBinaryFromReader);
      msg.setApplicationSequenceControl(value);
      break;
    case 17:
      var values = /** @type {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addCorporateAction(values[i]);
      }
      break;
    case 18:
      var value = new common_pb.MarketSegmentGrp;
      reader.readMessage(value,common_pb.MarketSegmentGrp.deserializeBinaryFromReader);
      msg.addMarketSegmentGrp(value);
      break;
    case 19:
      var value = new common_pb.SpreadOrBenchmarkCurveData;
      reader.readMessage(value,common_pb.SpreadOrBenchmarkCurveData.deserializeBinaryFromReader);
      msg.setSpreadOrBenchmarkCurveData(value);
      break;
    case 20:
      var value = new common_pb.Stipulations;
      reader.readMessage(value,common_pb.Stipulations.deserializeBinaryFromReader);
      msg.addStipulations(value);
      break;
    case 21:
      var value = new common_pb.YieldData;
      reader.readMessage(value,common_pb.YieldData.deserializeBinaryFromReader);
      msg.setYieldData(value);
      break;
    case 22:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SecuritiesReferenceData.SecurityDefinition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SecuritiesReferenceData.SecurityDefinition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityDefinition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      3,
      f
    );
  }
  f = message.getSecurityReqId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSecurityResponseId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSecurityResponseType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      common_pb.Instrument.serializeBinaryToWriter
    );
  }
  f = message.getClearingBusinessDate();
  if (f !== 0) {
    writer.writeSfixed32(
      11,
      f
    );
  }
  f = message.getInstrmtLegGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      common_pb.InstrmtLegGrp.serializeBinaryToWriter
    );
  }
  f = message.getInstrumentExtension();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      common_pb.InstrumentExtension.serializeBinaryToWriter
    );
  }
  f = message.getSecurityReportId();
  if (f !== 0) {
    writer.writeSfixed64(
      14,
      f
    );
  }
  f = message.getUndInstrmtGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      15,
      f,
      common_pb.UndInstrmtGrp.serializeBinaryToWriter
    );
  }
  f = message.getApplicationSequenceControl();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      common_pb.ApplicationSequenceControl.serializeBinaryToWriter
    );
  }
  f = message.getCorporateActionList();
  if (f.length > 0) {
    writer.writePackedEnum(
      17,
      f
    );
  }
  f = message.getMarketSegmentGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      common_pb.MarketSegmentGrp.serializeBinaryToWriter
    );
  }
  f = message.getSpreadOrBenchmarkCurveData();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      common_pb.SpreadOrBenchmarkCurveData.serializeBinaryToWriter
    );
  }
  f = message.getStipulationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      20,
      f,
      common_pb.Stipulations.serializeBinaryToWriter
    );
  }
  f = message.getYieldData();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      common_pb.YieldData.serializeBinaryToWriter
    );
  }
  f = message.getTransactTime();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string currency = 1;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string encoded_text = 2;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional sfixed64 encoded_text_len = 3;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string security_req_id = 4;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getSecurityReqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setSecurityReqId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string security_response_id = 5;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getSecurityResponseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setSecurityResponseId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional SecurityResponseTypeEnum security_response_type = 6;
 * @return {!proto.SecuritiesReferenceData.SecurityResponseTypeEnum}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getSecurityResponseType = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityResponseTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityResponseTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setSecurityResponseType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional Session.StandardHeader standard_header = 7;
 * @return {?proto.Session.StandardHeader}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 7));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 8;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 8));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string text = 9;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional Common.Instrument instrument = 10;
 * @return {?proto.Common.Instrument}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, common_pb.Instrument, 10));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional sfixed32 clearing_business_date = 11;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getClearingBusinessDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setClearingBusinessDate = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * repeated Common.InstrmtLegGrp instrmt_leg_grp = 12;
 * @return {!Array<!proto.Common.InstrmtLegGrp>}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getInstrmtLegGrpList = function() {
  return /** @type{!Array<!proto.Common.InstrmtLegGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.InstrmtLegGrp, 12));
};


/**
 * @param {!Array<!proto.Common.InstrmtLegGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setInstrmtLegGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.Common.InstrmtLegGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.InstrmtLegGrp}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.addInstrmtLegGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.Common.InstrmtLegGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.clearInstrmtLegGrpList = function() {
  return this.setInstrmtLegGrpList([]);
};


/**
 * optional Common.InstrumentExtension instrument_extension = 13;
 * @return {?proto.Common.InstrumentExtension}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getInstrumentExtension = function() {
  return /** @type{?proto.Common.InstrumentExtension} */ (
    jspb.Message.getWrapperField(this, common_pb.InstrumentExtension, 13));
};


/**
 * @param {?proto.Common.InstrumentExtension|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setInstrumentExtension = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.clearInstrumentExtension = function() {
  return this.setInstrumentExtension(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.hasInstrumentExtension = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional sfixed64 security_report_id = 14;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getSecurityReportId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setSecurityReportId = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * repeated Common.UndInstrmtGrp und_instrmt_grp = 15;
 * @return {!Array<!proto.Common.UndInstrmtGrp>}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getUndInstrmtGrpList = function() {
  return /** @type{!Array<!proto.Common.UndInstrmtGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.UndInstrmtGrp, 15));
};


/**
 * @param {!Array<!proto.Common.UndInstrmtGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setUndInstrmtGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 15, value);
};


/**
 * @param {!proto.Common.UndInstrmtGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndInstrmtGrp}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.addUndInstrmtGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.Common.UndInstrmtGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.clearUndInstrmtGrpList = function() {
  return this.setUndInstrmtGrpList([]);
};


/**
 * optional Common.ApplicationSequenceControl application_sequence_control = 16;
 * @return {?proto.Common.ApplicationSequenceControl}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getApplicationSequenceControl = function() {
  return /** @type{?proto.Common.ApplicationSequenceControl} */ (
    jspb.Message.getWrapperField(this, common_pb.ApplicationSequenceControl, 16));
};


/**
 * @param {?proto.Common.ApplicationSequenceControl|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setApplicationSequenceControl = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.clearApplicationSequenceControl = function() {
  return this.setApplicationSequenceControl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.hasApplicationSequenceControl = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * repeated CorporateActionEnum corporate_action = 17;
 * @return {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getCorporateActionList = function() {
  return /** @type {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>} */ (jspb.Message.getRepeatedField(this, 17));
};


/**
 * @param {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setCorporateActionList = function(value) {
  return jspb.Message.setField(this, 17, value || []);
};


/**
 * @param {!proto.SecuritiesReferenceData.CorporateActionEnum} value
 * @param {number=} opt_index
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.addCorporateAction = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 17, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.clearCorporateActionList = function() {
  return this.setCorporateActionList([]);
};


/**
 * repeated Common.MarketSegmentGrp market_segment_grp = 18;
 * @return {!Array<!proto.Common.MarketSegmentGrp>}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getMarketSegmentGrpList = function() {
  return /** @type{!Array<!proto.Common.MarketSegmentGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.MarketSegmentGrp, 18));
};


/**
 * @param {!Array<!proto.Common.MarketSegmentGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setMarketSegmentGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.Common.MarketSegmentGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.MarketSegmentGrp}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.addMarketSegmentGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.Common.MarketSegmentGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.clearMarketSegmentGrpList = function() {
  return this.setMarketSegmentGrpList([]);
};


/**
 * optional Common.SpreadOrBenchmarkCurveData spread_or_benchmark_curve_data = 19;
 * @return {?proto.Common.SpreadOrBenchmarkCurveData}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getSpreadOrBenchmarkCurveData = function() {
  return /** @type{?proto.Common.SpreadOrBenchmarkCurveData} */ (
    jspb.Message.getWrapperField(this, common_pb.SpreadOrBenchmarkCurveData, 19));
};


/**
 * @param {?proto.Common.SpreadOrBenchmarkCurveData|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setSpreadOrBenchmarkCurveData = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.clearSpreadOrBenchmarkCurveData = function() {
  return this.setSpreadOrBenchmarkCurveData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.hasSpreadOrBenchmarkCurveData = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * repeated Common.Stipulations stipulations = 20;
 * @return {!Array<!proto.Common.Stipulations>}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getStipulationsList = function() {
  return /** @type{!Array<!proto.Common.Stipulations>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Stipulations, 20));
};


/**
 * @param {!Array<!proto.Common.Stipulations>} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setStipulationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 20, value);
};


/**
 * @param {!proto.Common.Stipulations=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.Stipulations}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.addStipulations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 20, opt_value, proto.Common.Stipulations, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.clearStipulationsList = function() {
  return this.setStipulationsList([]);
};


/**
 * optional Common.YieldData yield_data = 21;
 * @return {?proto.Common.YieldData}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getYieldData = function() {
  return /** @type{?proto.Common.YieldData} */ (
    jspb.Message.getWrapperField(this, common_pb.YieldData, 21));
};


/**
 * @param {?proto.Common.YieldData|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setYieldData = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.clearYieldData = function() {
  return this.setYieldData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.hasYieldData = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional fix.Timestamp transact_time = 22;
 * @return {?proto.fix.Timestamp}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.getTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 22));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinition.prototype.setTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinition} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.clearTransactTime = function() {
  return this.setTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinition.prototype.hasTransactTime = function() {
  return jspb.Message.getField(this, 22) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.repeatedFields_ = [11,13];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.oneofGroups_ = [[6,7],[9,10]];

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.TradingSessionIdUnionCase = {
  TRADING_SESSION_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_ID: 6,
  TRADING_SESSION_ID_RESERVED100PLUS: 7
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityStatusRequest.TradingSessionIdUnionCase}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.getTradingSessionIdUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityStatusRequest.TradingSessionIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityStatusRequest.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.TradingSessionSubIdUnionCase = {
  TRADING_SESSION_SUB_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_SUB_ID: 9,
  TRADING_SESSION_SUB_ID_RESERVED100PLUS: 10
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityStatusRequest.TradingSessionSubIdUnionCase}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.getTradingSessionSubIdUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityStatusRequest.TradingSessionSubIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityStatusRequest.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.SecuritiesReferenceData.SecurityStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SecuritiesReferenceData.SecurityStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    currency: jspb.Message.getFieldWithDefault(msg, 1, ""),
    securityStatusReqId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    subscriptionRequestType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 6, 0),
    tradingSessionIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 7, 0),
    instrument: (f = msg.getInstrument()) && common_pb.Instrument.toObject(includeInstance, f),
    tradingSessionSubId: jspb.Message.getFieldWithDefault(msg, 9, 0),
    tradingSessionSubIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 10, 0),
    instrmtLegGrpList: jspb.Message.toObjectList(msg.getInstrmtLegGrpList(),
    common_pb.InstrmtLegGrp.toObject, includeInstance),
    instrumentExtension: (f = msg.getInstrumentExtension()) && common_pb.InstrumentExtension.toObject(includeInstance, f),
    undInstrmtGrpList: jspb.Message.toObjectList(msg.getUndInstrmtGrpList(),
    common_pb.UndInstrmtGrp.toObject, includeInstance),
    marketId: jspb.Message.getFieldWithDefault(msg, 14, ""),
    marketSegmentId: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SecuritiesReferenceData.SecurityStatusRequest;
  return proto.SecuritiesReferenceData.SecurityStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SecuritiesReferenceData.SecurityStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityStatusReqId(value);
      break;
    case 3:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 4:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 5:
      var value = /** @type {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum} */ (reader.readEnum());
      msg.setSubscriptionRequestType(value);
      break;
    case 6:
      var value = /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionIdReserved100plus(value);
      break;
    case 8:
      var value = new common_pb.Instrument;
      reader.readMessage(value,common_pb.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 9:
      var value = /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (reader.readEnum());
      msg.setTradingSessionSubId(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionSubIdReserved100plus(value);
      break;
    case 11:
      var value = new common_pb.InstrmtLegGrp;
      reader.readMessage(value,common_pb.InstrmtLegGrp.deserializeBinaryFromReader);
      msg.addInstrmtLegGrp(value);
      break;
    case 12:
      var value = new common_pb.InstrumentExtension;
      reader.readMessage(value,common_pb.InstrumentExtension.deserializeBinaryFromReader);
      msg.setInstrumentExtension(value);
      break;
    case 13:
      var value = new common_pb.UndInstrmtGrp;
      reader.readMessage(value,common_pb.UndInstrmtGrp.deserializeBinaryFromReader);
      msg.addUndInstrmtGrp(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketSegmentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SecuritiesReferenceData.SecurityStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SecuritiesReferenceData.SecurityStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSecurityStatusReqId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getSubscriptionRequestType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeFixed32(
      7,
      f
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      common_pb.Instrument.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeFixed32(
      10,
      f
    );
  }
  f = message.getInstrmtLegGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      common_pb.InstrmtLegGrp.serializeBinaryToWriter
    );
  }
  f = message.getInstrumentExtension();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      common_pb.InstrumentExtension.serializeBinaryToWriter
    );
  }
  f = message.getUndInstrmtGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      common_pb.UndInstrmtGrp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getMarketSegmentId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional string currency = 1;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string security_status_req_id = 2;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.getSecurityStatusReqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.setSecurityStatusReqId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Session.StandardHeader standard_header = 3;
 * @return {?proto.Session.StandardHeader}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 3));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 4;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 4));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional SubscriptionRequestTypeEnum subscription_request_type = 5;
 * @return {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.getSubscriptionRequestType = function() {
  return /** @type {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.setSubscriptionRequestType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional TradingSessionIDEnum trading_session_id = 6;
 * @return {!proto.SecuritiesReferenceData.TradingSessionIDEnum}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.getTradingSessionId = function() {
  return /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.TradingSessionIDEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setOneofField(this, 6, proto.SecuritiesReferenceData.SecurityStatusRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.clearTradingSessionId = function() {
  return jspb.Message.setOneofField(this, 6, proto.SecuritiesReferenceData.SecurityStatusRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.hasTradingSessionId = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional fixed32 trading_session_id_reserved100plus = 7;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.getTradingSessionIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.setTradingSessionIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 7, proto.SecuritiesReferenceData.SecurityStatusRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.clearTradingSessionIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 7, proto.SecuritiesReferenceData.SecurityStatusRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.hasTradingSessionIdReserved100plus = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Common.Instrument instrument = 8;
 * @return {?proto.Common.Instrument}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, common_pb.Instrument, 8));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional TradingSessionSubIDEnum trading_session_sub_id = 9;
 * @return {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.getTradingSessionSubId = function() {
  return /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.setTradingSessionSubId = function(value) {
  return jspb.Message.setOneofField(this, 9, proto.SecuritiesReferenceData.SecurityStatusRequest.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.clearTradingSessionSubId = function() {
  return jspb.Message.setOneofField(this, 9, proto.SecuritiesReferenceData.SecurityStatusRequest.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.hasTradingSessionSubId = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional fixed32 trading_session_sub_id_reserved100plus = 10;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.getTradingSessionSubIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.setTradingSessionSubIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 10, proto.SecuritiesReferenceData.SecurityStatusRequest.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.clearTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 10, proto.SecuritiesReferenceData.SecurityStatusRequest.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.hasTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * repeated Common.InstrmtLegGrp instrmt_leg_grp = 11;
 * @return {!Array<!proto.Common.InstrmtLegGrp>}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.getInstrmtLegGrpList = function() {
  return /** @type{!Array<!proto.Common.InstrmtLegGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.InstrmtLegGrp, 11));
};


/**
 * @param {!Array<!proto.Common.InstrmtLegGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.setInstrmtLegGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.Common.InstrmtLegGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.InstrmtLegGrp}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.addInstrmtLegGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.Common.InstrmtLegGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.clearInstrmtLegGrpList = function() {
  return this.setInstrmtLegGrpList([]);
};


/**
 * optional Common.InstrumentExtension instrument_extension = 12;
 * @return {?proto.Common.InstrumentExtension}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.getInstrumentExtension = function() {
  return /** @type{?proto.Common.InstrumentExtension} */ (
    jspb.Message.getWrapperField(this, common_pb.InstrumentExtension, 12));
};


/**
 * @param {?proto.Common.InstrumentExtension|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.setInstrumentExtension = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.clearInstrumentExtension = function() {
  return this.setInstrumentExtension(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.hasInstrumentExtension = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * repeated Common.UndInstrmtGrp und_instrmt_grp = 13;
 * @return {!Array<!proto.Common.UndInstrmtGrp>}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.getUndInstrmtGrpList = function() {
  return /** @type{!Array<!proto.Common.UndInstrmtGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.UndInstrmtGrp, 13));
};


/**
 * @param {!Array<!proto.Common.UndInstrmtGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.setUndInstrmtGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.Common.UndInstrmtGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndInstrmtGrp}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.addUndInstrmtGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.Common.UndInstrmtGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.clearUndInstrmtGrpList = function() {
  return this.setUndInstrmtGrpList([]);
};


/**
 * optional string market_id = 14;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string market_segment_id = 15;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.getMarketSegmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatusRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityStatusRequest.prototype.setMarketSegmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SecuritiesReferenceData.SecurityStatus.repeatedFields_ = [3,6,30,32];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_ = [[7,8],[14,15],[19,20],[27,28],[38,39]];

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityStatus.HaltReasonUnionCase = {
  HALT_REASON_UNION_NOT_SET: 0,
  HALT_REASON: 7,
  HALT_REASON_RESERVED100PLUS: 8
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityStatus.HaltReasonUnionCase}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getHaltReasonUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityStatus.HaltReasonUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityStatus.SecurityTradingStatusUnionCase = {
  SECURITY_TRADING_STATUS_UNION_NOT_SET: 0,
  SECURITY_TRADING_STATUS: 14,
  SECURITY_TRADING_STATUS_RESERVED100PLUS: 15
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityStatus.SecurityTradingStatusUnionCase}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getSecurityTradingStatusUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityStatus.SecurityTradingStatusUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[1]));
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityStatus.TradingSessionIdUnionCase = {
  TRADING_SESSION_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_ID: 19,
  TRADING_SESSION_ID_RESERVED100PLUS: 20
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityStatus.TradingSessionIdUnionCase}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getTradingSessionIdUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityStatus.TradingSessionIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[2]));
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityStatus.TradingSessionSubIdUnionCase = {
  TRADING_SESSION_SUB_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_SUB_ID: 27,
  TRADING_SESSION_SUB_ID_RESERVED100PLUS: 28
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityStatus.TradingSessionSubIdUnionCase}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getTradingSessionSubIdUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityStatus.TradingSessionSubIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[3]));
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityStatus.SecurityTradingEventUnionCase = {
  SECURITY_TRADING_EVENT_UNION_NOT_SET: 0,
  SECURITY_TRADING_EVENT: 38,
  SECURITY_TRADING_EVENT_RESERVED100PLUS: 39
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityStatus.SecurityTradingEventUnionCase}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getSecurityTradingEventUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityStatus.SecurityTradingEventUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[4]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.SecuritiesReferenceData.SecurityStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SecuritiesReferenceData.SecurityStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    adjustment: jspb.Message.getFieldWithDefault(msg, 1, 0),
    buyVolume: (f = msg.getBuyVolume()) && fix_pb.Decimal64.toObject(includeInstance, f),
    corporateActionList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    currency: jspb.Message.getFieldWithDefault(msg, 4, ""),
    dueToRelated: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    financialStatusList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    haltReason: jspb.Message.getFieldWithDefault(msg, 7, 0),
    haltReasonReserved100plus: jspb.Message.getFieldWithDefault(msg, 8, 0),
    highPx: (f = msg.getHighPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    inViewOfCommon: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    lastPx: (f = msg.getLastPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    lowPx: (f = msg.getLowPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    securityStatusReqId: jspb.Message.getFieldWithDefault(msg, 13, ""),
    securityTradingStatus: jspb.Message.getFieldWithDefault(msg, 14, 0),
    securityTradingStatusReserved100plus: jspb.Message.getFieldWithDefault(msg, 15, 0),
    sellVolume: (f = msg.getSellVolume()) && fix_pb.Decimal64.toObject(includeInstance, f),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 19, 0),
    tradingSessionIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 20, 0),
    transactTime: (f = msg.getTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    unsolicitedIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 22, false),
    encodedText: jspb.Message.getFieldWithDefault(msg, 23, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 24, 0),
    instrument: (f = msg.getInstrument()) && common_pb.Instrument.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 26, ""),
    tradingSessionSubId: jspb.Message.getFieldWithDefault(msg, 27, 0),
    tradingSessionSubIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 28, 0),
    firstPx: (f = msg.getFirstPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    instrmtLegGrpList: jspb.Message.toObjectList(msg.getInstrmtLegGrpList(),
    common_pb.InstrmtLegGrp.toObject, includeInstance),
    instrumentExtension: (f = msg.getInstrumentExtension()) && common_pb.InstrumentExtension.toObject(includeInstance, f),
    undInstrmtGrpList: jspb.Message.toObjectList(msg.getUndInstrmtGrpList(),
    common_pb.UndInstrmtGrp.toObject, includeInstance),
    applicationSequenceControl: (f = msg.getApplicationSequenceControl()) && common_pb.ApplicationSequenceControl.toObject(includeInstance, f),
    marketDepth: jspb.Message.getFieldWithDefault(msg, 34, 0),
    marketId: jspb.Message.getFieldWithDefault(msg, 35, ""),
    marketSegmentId: jspb.Message.getFieldWithDefault(msg, 36, ""),
    mdBookType: jspb.Message.getFieldWithDefault(msg, 37, 0),
    securityTradingEvent: jspb.Message.getFieldWithDefault(msg, 38, 0),
    securityTradingEventReserved100plus: jspb.Message.getFieldWithDefault(msg, 39, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus}
 */
proto.SecuritiesReferenceData.SecurityStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SecuritiesReferenceData.SecurityStatus;
  return proto.SecuritiesReferenceData.SecurityStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SecuritiesReferenceData.SecurityStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus}
 */
proto.SecuritiesReferenceData.SecurityStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.SecuritiesReferenceData.AdjustmentEnum} */ (reader.readEnum());
      msg.setAdjustment(value);
      break;
    case 2:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setBuyVolume(value);
      break;
    case 3:
      var values = /** @type {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addCorporateAction(values[i]);
      }
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDueToRelated(value);
      break;
    case 6:
      var values = /** @type {!Array<!proto.SecuritiesReferenceData.FinancialStatusEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addFinancialStatus(values[i]);
      }
      break;
    case 7:
      var value = /** @type {!proto.SecuritiesReferenceData.HaltReasonEnum} */ (reader.readEnum());
      msg.setHaltReason(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setHaltReasonReserved100plus(value);
      break;
    case 9:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setHighPx(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInViewOfCommon(value);
      break;
    case 11:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLastPx(value);
      break;
    case 12:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLowPx(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityStatusReqId(value);
      break;
    case 14:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityTradingStatusEnum} */ (reader.readEnum());
      msg.setSecurityTradingStatus(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSecurityTradingStatusReserved100plus(value);
      break;
    case 16:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setSellVolume(value);
      break;
    case 17:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 18:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 19:
      var value = /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionIdReserved100plus(value);
      break;
    case 21:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactTime(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUnsolicitedIndicator(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 25:
      var value = new common_pb.Instrument;
      reader.readMessage(value,common_pb.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 27:
      var value = /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (reader.readEnum());
      msg.setTradingSessionSubId(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionSubIdReserved100plus(value);
      break;
    case 29:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setFirstPx(value);
      break;
    case 30:
      var value = new common_pb.InstrmtLegGrp;
      reader.readMessage(value,common_pb.InstrmtLegGrp.deserializeBinaryFromReader);
      msg.addInstrmtLegGrp(value);
      break;
    case 31:
      var value = new common_pb.InstrumentExtension;
      reader.readMessage(value,common_pb.InstrumentExtension.deserializeBinaryFromReader);
      msg.setInstrumentExtension(value);
      break;
    case 32:
      var value = new common_pb.UndInstrmtGrp;
      reader.readMessage(value,common_pb.UndInstrmtGrp.deserializeBinaryFromReader);
      msg.addUndInstrmtGrp(value);
      break;
    case 33:
      var value = new common_pb.ApplicationSequenceControl;
      reader.readMessage(value,common_pb.ApplicationSequenceControl.deserializeBinaryFromReader);
      msg.setApplicationSequenceControl(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setMarketDepth(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketSegmentId(value);
      break;
    case 37:
      var value = /** @type {!proto.SecuritiesReferenceData.MDBookTypeEnum} */ (reader.readEnum());
      msg.setMdBookType(value);
      break;
    case 38:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityTradingEventEnum} */ (reader.readEnum());
      msg.setSecurityTradingEvent(value);
      break;
    case 39:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSecurityTradingEventReserved100plus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SecuritiesReferenceData.SecurityStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SecuritiesReferenceData.SecurityStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdjustment();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getBuyVolume();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getCorporateActionList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDueToRelated();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getFinancialStatusList();
  if (f.length > 0) {
    writer.writePackedEnum(
      6,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.HaltReasonEnum} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeFixed32(
      8,
      f
    );
  }
  f = message.getHighPx();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getInViewOfCommon();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getLastPx();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLowPx();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getSecurityStatusReqId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.SecurityTradingStatusEnum} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeFixed32(
      15,
      f
    );
  }
  f = message.getSellVolume();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (jspb.Message.getField(message, 19));
  if (f != null) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 20));
  if (f != null) {
    writer.writeFixed32(
      20,
      f
    );
  }
  f = message.getTransactTime();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUnsolicitedIndicator();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      24,
      f
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      common_pb.Instrument.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (jspb.Message.getField(message, 27));
  if (f != null) {
    writer.writeEnum(
      27,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 28));
  if (f != null) {
    writer.writeFixed32(
      28,
      f
    );
  }
  f = message.getFirstPx();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getInstrmtLegGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      30,
      f,
      common_pb.InstrmtLegGrp.serializeBinaryToWriter
    );
  }
  f = message.getInstrumentExtension();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      common_pb.InstrumentExtension.serializeBinaryToWriter
    );
  }
  f = message.getUndInstrmtGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      32,
      f,
      common_pb.UndInstrmtGrp.serializeBinaryToWriter
    );
  }
  f = message.getApplicationSequenceControl();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      common_pb.ApplicationSequenceControl.serializeBinaryToWriter
    );
  }
  f = message.getMarketDepth();
  if (f !== 0) {
    writer.writeSfixed64(
      34,
      f
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getMarketSegmentId();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getMdBookType();
  if (f !== 0.0) {
    writer.writeEnum(
      37,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.SecurityTradingEventEnum} */ (jspb.Message.getField(message, 38));
  if (f != null) {
    writer.writeEnum(
      38,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 39));
  if (f != null) {
    writer.writeFixed32(
      39,
      f
    );
  }
};


/**
 * optional AdjustmentEnum adjustment = 1;
 * @return {!proto.SecuritiesReferenceData.AdjustmentEnum}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getAdjustment = function() {
  return /** @type {!proto.SecuritiesReferenceData.AdjustmentEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.AdjustmentEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setAdjustment = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional fix.Decimal64 buy_volume = 2;
 * @return {?proto.fix.Decimal64}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getBuyVolume = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 2));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
*/
proto.SecuritiesReferenceData.SecurityStatus.prototype.setBuyVolume = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearBuyVolume = function() {
  return this.setBuyVolume(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasBuyVolume = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated CorporateActionEnum corporate_action = 3;
 * @return {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getCorporateActionList = function() {
  return /** @type {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setCorporateActionList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.SecuritiesReferenceData.CorporateActionEnum} value
 * @param {number=} opt_index
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.addCorporateAction = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearCorporateActionList = function() {
  return this.setCorporateActionList([]);
};


/**
 * optional string currency = 4;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool due_to_related = 5;
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getDueToRelated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setDueToRelated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated FinancialStatusEnum financial_status = 6;
 * @return {!Array<!proto.SecuritiesReferenceData.FinancialStatusEnum>}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getFinancialStatusList = function() {
  return /** @type {!Array<!proto.SecuritiesReferenceData.FinancialStatusEnum>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<!proto.SecuritiesReferenceData.FinancialStatusEnum>} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setFinancialStatusList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!proto.SecuritiesReferenceData.FinancialStatusEnum} value
 * @param {number=} opt_index
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.addFinancialStatus = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearFinancialStatusList = function() {
  return this.setFinancialStatusList([]);
};


/**
 * optional HaltReasonEnum halt_reason = 7;
 * @return {!proto.SecuritiesReferenceData.HaltReasonEnum}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getHaltReason = function() {
  return /** @type {!proto.SecuritiesReferenceData.HaltReasonEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.HaltReasonEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setHaltReason = function(value) {
  return jspb.Message.setOneofField(this, 7, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearHaltReason = function() {
  return jspb.Message.setOneofField(this, 7, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasHaltReason = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional fixed32 halt_reason_reserved100plus = 8;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getHaltReasonReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setHaltReasonReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 8, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearHaltReasonReserved100plus = function() {
  return jspb.Message.setOneofField(this, 8, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasHaltReasonReserved100plus = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional fix.Decimal64 high_px = 9;
 * @return {?proto.fix.Decimal64}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getHighPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 9));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
*/
proto.SecuritiesReferenceData.SecurityStatus.prototype.setHighPx = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearHighPx = function() {
  return this.setHighPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasHighPx = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool in_view_of_common = 10;
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getInViewOfCommon = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setInViewOfCommon = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional fix.Decimal64 last_px = 11;
 * @return {?proto.fix.Decimal64}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getLastPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 11));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
*/
proto.SecuritiesReferenceData.SecurityStatus.prototype.setLastPx = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearLastPx = function() {
  return this.setLastPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasLastPx = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional fix.Decimal64 low_px = 12;
 * @return {?proto.fix.Decimal64}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getLowPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 12));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
*/
proto.SecuritiesReferenceData.SecurityStatus.prototype.setLowPx = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearLowPx = function() {
  return this.setLowPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasLowPx = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string security_status_req_id = 13;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getSecurityStatusReqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setSecurityStatusReqId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional SecurityTradingStatusEnum security_trading_status = 14;
 * @return {!proto.SecuritiesReferenceData.SecurityTradingStatusEnum}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getSecurityTradingStatus = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityTradingStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityTradingStatusEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setSecurityTradingStatus = function(value) {
  return jspb.Message.setOneofField(this, 14, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearSecurityTradingStatus = function() {
  return jspb.Message.setOneofField(this, 14, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasSecurityTradingStatus = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional fixed32 security_trading_status_reserved100plus = 15;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getSecurityTradingStatusReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setSecurityTradingStatusReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 15, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearSecurityTradingStatusReserved100plus = function() {
  return jspb.Message.setOneofField(this, 15, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasSecurityTradingStatusReserved100plus = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional fix.Decimal64 sell_volume = 16;
 * @return {?proto.fix.Decimal64}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getSellVolume = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 16));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
*/
proto.SecuritiesReferenceData.SecurityStatus.prototype.setSellVolume = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearSellVolume = function() {
  return this.setSellVolume(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasSellVolume = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional Session.StandardHeader standard_header = 17;
 * @return {?proto.Session.StandardHeader}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 17));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
*/
proto.SecuritiesReferenceData.SecurityStatus.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 18;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 18));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
*/
proto.SecuritiesReferenceData.SecurityStatus.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional TradingSessionIDEnum trading_session_id = 19;
 * @return {!proto.SecuritiesReferenceData.TradingSessionIDEnum}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getTradingSessionId = function() {
  return /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.TradingSessionIDEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setOneofField(this, 19, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[2], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearTradingSessionId = function() {
  return jspb.Message.setOneofField(this, 19, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[2], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasTradingSessionId = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional fixed32 trading_session_id_reserved100plus = 20;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getTradingSessionIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setTradingSessionIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 20, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[2], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearTradingSessionIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 20, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[2], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasTradingSessionIdReserved100plus = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional fix.Timestamp transact_time = 21;
 * @return {?proto.fix.Timestamp}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 21));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
*/
proto.SecuritiesReferenceData.SecurityStatus.prototype.setTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearTransactTime = function() {
  return this.setTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasTransactTime = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional bool unsolicited_indicator = 22;
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getUnsolicitedIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setUnsolicitedIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};


/**
 * optional string encoded_text = 23;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional sfixed64 encoded_text_len = 24;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional Common.Instrument instrument = 25;
 * @return {?proto.Common.Instrument}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, common_pb.Instrument, 25));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
*/
proto.SecuritiesReferenceData.SecurityStatus.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional string text = 26;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional TradingSessionSubIDEnum trading_session_sub_id = 27;
 * @return {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getTradingSessionSubId = function() {
  return /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setTradingSessionSubId = function(value) {
  return jspb.Message.setOneofField(this, 27, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[3], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearTradingSessionSubId = function() {
  return jspb.Message.setOneofField(this, 27, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[3], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasTradingSessionSubId = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional fixed32 trading_session_sub_id_reserved100plus = 28;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getTradingSessionSubIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setTradingSessionSubIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 28, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[3], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 28, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[3], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional fix.Decimal64 first_px = 29;
 * @return {?proto.fix.Decimal64}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getFirstPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 29));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
*/
proto.SecuritiesReferenceData.SecurityStatus.prototype.setFirstPx = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearFirstPx = function() {
  return this.setFirstPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasFirstPx = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * repeated Common.InstrmtLegGrp instrmt_leg_grp = 30;
 * @return {!Array<!proto.Common.InstrmtLegGrp>}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getInstrmtLegGrpList = function() {
  return /** @type{!Array<!proto.Common.InstrmtLegGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.InstrmtLegGrp, 30));
};


/**
 * @param {!Array<!proto.Common.InstrmtLegGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
*/
proto.SecuritiesReferenceData.SecurityStatus.prototype.setInstrmtLegGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 30, value);
};


/**
 * @param {!proto.Common.InstrmtLegGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.InstrmtLegGrp}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.addInstrmtLegGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 30, opt_value, proto.Common.InstrmtLegGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearInstrmtLegGrpList = function() {
  return this.setInstrmtLegGrpList([]);
};


/**
 * optional Common.InstrumentExtension instrument_extension = 31;
 * @return {?proto.Common.InstrumentExtension}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getInstrumentExtension = function() {
  return /** @type{?proto.Common.InstrumentExtension} */ (
    jspb.Message.getWrapperField(this, common_pb.InstrumentExtension, 31));
};


/**
 * @param {?proto.Common.InstrumentExtension|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
*/
proto.SecuritiesReferenceData.SecurityStatus.prototype.setInstrumentExtension = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearInstrumentExtension = function() {
  return this.setInstrumentExtension(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasInstrumentExtension = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * repeated Common.UndInstrmtGrp und_instrmt_grp = 32;
 * @return {!Array<!proto.Common.UndInstrmtGrp>}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getUndInstrmtGrpList = function() {
  return /** @type{!Array<!proto.Common.UndInstrmtGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.UndInstrmtGrp, 32));
};


/**
 * @param {!Array<!proto.Common.UndInstrmtGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
*/
proto.SecuritiesReferenceData.SecurityStatus.prototype.setUndInstrmtGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 32, value);
};


/**
 * @param {!proto.Common.UndInstrmtGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndInstrmtGrp}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.addUndInstrmtGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 32, opt_value, proto.Common.UndInstrmtGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearUndInstrmtGrpList = function() {
  return this.setUndInstrmtGrpList([]);
};


/**
 * optional Common.ApplicationSequenceControl application_sequence_control = 33;
 * @return {?proto.Common.ApplicationSequenceControl}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getApplicationSequenceControl = function() {
  return /** @type{?proto.Common.ApplicationSequenceControl} */ (
    jspb.Message.getWrapperField(this, common_pb.ApplicationSequenceControl, 33));
};


/**
 * @param {?proto.Common.ApplicationSequenceControl|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
*/
proto.SecuritiesReferenceData.SecurityStatus.prototype.setApplicationSequenceControl = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearApplicationSequenceControl = function() {
  return this.setApplicationSequenceControl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasApplicationSequenceControl = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional sfixed64 market_depth = 34;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getMarketDepth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setMarketDepth = function(value) {
  return jspb.Message.setProto3IntField(this, 34, value);
};


/**
 * optional string market_id = 35;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional string market_segment_id = 36;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getMarketSegmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setMarketSegmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional MDBookTypeEnum md_book_type = 37;
 * @return {!proto.SecuritiesReferenceData.MDBookTypeEnum}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getMdBookType = function() {
  return /** @type {!proto.SecuritiesReferenceData.MDBookTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 37, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.MDBookTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setMdBookType = function(value) {
  return jspb.Message.setProto3EnumField(this, 37, value);
};


/**
 * optional SecurityTradingEventEnum security_trading_event = 38;
 * @return {!proto.SecuritiesReferenceData.SecurityTradingEventEnum}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getSecurityTradingEvent = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityTradingEventEnum} */ (jspb.Message.getFieldWithDefault(this, 38, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityTradingEventEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setSecurityTradingEvent = function(value) {
  return jspb.Message.setOneofField(this, 38, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[4], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearSecurityTradingEvent = function() {
  return jspb.Message.setOneofField(this, 38, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[4], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasSecurityTradingEvent = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional fixed32 security_trading_event_reserved100plus = 39;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.getSecurityTradingEventReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 39, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.setSecurityTradingEventReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 39, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[4], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityStatus} returns this
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.clearSecurityTradingEventReserved100plus = function() {
  return jspb.Message.setOneofField(this, 39, proto.SecuritiesReferenceData.SecurityStatus.oneofGroups_[4], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityStatus.prototype.hasSecurityTradingEventReserved100plus = function() {
  return jspb.Message.getField(this, 39) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.oneofGroups_ = [[7,8],[9,10]];

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.TradingSessionIdUnionCase = {
  TRADING_SESSION_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_ID: 7,
  TRADING_SESSION_ID_RESERVED100PLUS: 8
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityTypeRequest.TradingSessionIdUnionCase}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.getTradingSessionIdUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityTypeRequest.TradingSessionIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityTypeRequest.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.TradingSessionSubIdUnionCase = {
  TRADING_SESSION_SUB_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_SUB_ID: 9,
  TRADING_SESSION_SUB_ID_RESERVED100PLUS: 10
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityTypeRequest.TradingSessionSubIdUnionCase}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.getTradingSessionSubIdUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityTypeRequest.TradingSessionSubIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityTypeRequest.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.SecuritiesReferenceData.SecurityTypeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SecuritiesReferenceData.SecurityTypeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    encodedText: jspb.Message.getFieldWithDefault(msg, 1, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 2, 0),
    securityReqId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 6, ""),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 7, 0),
    tradingSessionIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 8, 0),
    tradingSessionSubId: jspb.Message.getFieldWithDefault(msg, 9, 0),
    tradingSessionSubIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 10, 0),
    product: jspb.Message.getFieldWithDefault(msg, 11, 0),
    securitySubType: jspb.Message.getFieldWithDefault(msg, 12, ""),
    securityType: jspb.Message.getFieldWithDefault(msg, 13, 0),
    marketId: jspb.Message.getFieldWithDefault(msg, 14, ""),
    marketSegmentId: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SecuritiesReferenceData.SecurityTypeRequest;
  return proto.SecuritiesReferenceData.SecurityTypeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SecuritiesReferenceData.SecurityTypeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityReqId(value);
      break;
    case 4:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 5:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 7:
      var value = /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionIdReserved100plus(value);
      break;
    case 9:
      var value = /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (reader.readEnum());
      msg.setTradingSessionSubId(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionSubIdReserved100plus(value);
      break;
    case 11:
      var value = /** @type {!proto.SecuritiesReferenceData.ProductEnum} */ (reader.readEnum());
      msg.setProduct(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecuritySubType(value);
      break;
    case 13:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityTypeEnum} */ (reader.readEnum());
      msg.setSecurityType(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketSegmentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SecuritiesReferenceData.SecurityTypeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SecuritiesReferenceData.SecurityTypeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      2,
      f
    );
  }
  f = message.getSecurityReqId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeFixed32(
      8,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeFixed32(
      10,
      f
    );
  }
  f = message.getProduct();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getSecuritySubType();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getSecurityType();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getMarketSegmentId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional string encoded_text = 1;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional sfixed64 encoded_text_len = 2;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string security_req_id = 3;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.getSecurityReqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.setSecurityReqId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Session.StandardHeader standard_header = 4;
 * @return {?proto.Session.StandardHeader}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 4));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 5;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 5));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string text = 6;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional TradingSessionIDEnum trading_session_id = 7;
 * @return {!proto.SecuritiesReferenceData.TradingSessionIDEnum}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.getTradingSessionId = function() {
  return /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.TradingSessionIDEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setOneofField(this, 7, proto.SecuritiesReferenceData.SecurityTypeRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.clearTradingSessionId = function() {
  return jspb.Message.setOneofField(this, 7, proto.SecuritiesReferenceData.SecurityTypeRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.hasTradingSessionId = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional fixed32 trading_session_id_reserved100plus = 8;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.getTradingSessionIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.setTradingSessionIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 8, proto.SecuritiesReferenceData.SecurityTypeRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.clearTradingSessionIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 8, proto.SecuritiesReferenceData.SecurityTypeRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.hasTradingSessionIdReserved100plus = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional TradingSessionSubIDEnum trading_session_sub_id = 9;
 * @return {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.getTradingSessionSubId = function() {
  return /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.setTradingSessionSubId = function(value) {
  return jspb.Message.setOneofField(this, 9, proto.SecuritiesReferenceData.SecurityTypeRequest.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.clearTradingSessionSubId = function() {
  return jspb.Message.setOneofField(this, 9, proto.SecuritiesReferenceData.SecurityTypeRequest.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.hasTradingSessionSubId = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional fixed32 trading_session_sub_id_reserved100plus = 10;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.getTradingSessionSubIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.setTradingSessionSubIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 10, proto.SecuritiesReferenceData.SecurityTypeRequest.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.clearTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 10, proto.SecuritiesReferenceData.SecurityTypeRequest.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.hasTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional ProductEnum product = 11;
 * @return {!proto.SecuritiesReferenceData.ProductEnum}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.getProduct = function() {
  return /** @type {!proto.SecuritiesReferenceData.ProductEnum} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.ProductEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.setProduct = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional string security_sub_type = 12;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.getSecuritySubType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.setSecuritySubType = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional SecurityTypeEnum security_type = 13;
 * @return {!proto.SecuritiesReferenceData.SecurityTypeEnum}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.getSecurityType = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.setSecurityType = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional string market_id = 14;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string market_segment_id = 15;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.getMarketSegmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypeRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityTypeRequest.prototype.setMarketSegmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SecuritiesReferenceData.SecurityTypes.repeatedFields_ = [16];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.SecuritiesReferenceData.SecurityTypes.oneofGroups_ = [[11,12],[13,14]];

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityTypes.TradingSessionIdUnionCase = {
  TRADING_SESSION_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_ID: 11,
  TRADING_SESSION_ID_RESERVED100PLUS: 12
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityTypes.TradingSessionIdUnionCase}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getTradingSessionIdUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityTypes.TradingSessionIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityTypes.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityTypes.TradingSessionSubIdUnionCase = {
  TRADING_SESSION_SUB_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_SUB_ID: 13,
  TRADING_SESSION_SUB_ID_RESERVED100PLUS: 14
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityTypes.TradingSessionSubIdUnionCase}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getTradingSessionSubIdUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityTypes.TradingSessionSubIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityTypes.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.toObject = function(opt_includeInstance) {
  return proto.SecuritiesReferenceData.SecurityTypes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SecuritiesReferenceData.SecurityTypes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityTypes.toObject = function(includeInstance, msg) {
  var f, obj = {
    encodedText: jspb.Message.getFieldWithDefault(msg, 1, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 2, 0),
    securityReqId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    securityResponseId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    securityResponseType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    subscriptionRequestType: jspb.Message.getFieldWithDefault(msg, 8, 0),
    text: jspb.Message.getFieldWithDefault(msg, 9, ""),
    totNoSecurityTypes: jspb.Message.getFieldWithDefault(msg, 10, 0),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 11, 0),
    tradingSessionIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 12, 0),
    tradingSessionSubId: jspb.Message.getFieldWithDefault(msg, 13, 0),
    tradingSessionSubIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 14, 0),
    lastFragment: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    secTypesGrpList: jspb.Message.toObjectList(msg.getSecTypesGrpList(),
    proto.SecuritiesReferenceData.SecTypesGrp.toObject, includeInstance),
    applicationSequenceControl: (f = msg.getApplicationSequenceControl()) && common_pb.ApplicationSequenceControl.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 18, ""),
    marketSegmentId: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SecuritiesReferenceData.SecurityTypes}
 */
proto.SecuritiesReferenceData.SecurityTypes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SecuritiesReferenceData.SecurityTypes;
  return proto.SecuritiesReferenceData.SecurityTypes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SecuritiesReferenceData.SecurityTypes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SecuritiesReferenceData.SecurityTypes}
 */
proto.SecuritiesReferenceData.SecurityTypes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityReqId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityResponseId(value);
      break;
    case 5:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityResponseTypeEnum} */ (reader.readEnum());
      msg.setSecurityResponseType(value);
      break;
    case 6:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 7:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 8:
      var value = /** @type {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum} */ (reader.readEnum());
      msg.setSubscriptionRequestType(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setTotNoSecurityTypes(value);
      break;
    case 11:
      var value = /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionIdReserved100plus(value);
      break;
    case 13:
      var value = /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (reader.readEnum());
      msg.setTradingSessionSubId(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionSubIdReserved100plus(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLastFragment(value);
      break;
    case 16:
      var value = new proto.SecuritiesReferenceData.SecTypesGrp;
      reader.readMessage(value,proto.SecuritiesReferenceData.SecTypesGrp.deserializeBinaryFromReader);
      msg.addSecTypesGrp(value);
      break;
    case 17:
      var value = new common_pb.ApplicationSequenceControl;
      reader.readMessage(value,common_pb.ApplicationSequenceControl.deserializeBinaryFromReader);
      msg.setApplicationSequenceControl(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketSegmentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SecuritiesReferenceData.SecurityTypes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SecuritiesReferenceData.SecurityTypes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityTypes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      2,
      f
    );
  }
  f = message.getSecurityReqId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSecurityResponseId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSecurityResponseType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getSubscriptionRequestType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTotNoSecurityTypes();
  if (f !== 0) {
    writer.writeSfixed64(
      10,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeFixed32(
      12,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeFixed32(
      14,
      f
    );
  }
  f = message.getLastFragment();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getSecTypesGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      proto.SecuritiesReferenceData.SecTypesGrp.serializeBinaryToWriter
    );
  }
  f = message.getApplicationSequenceControl();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      common_pb.ApplicationSequenceControl.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getMarketSegmentId();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional string encoded_text = 1;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional sfixed64 encoded_text_len = 2;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string security_req_id = 3;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getSecurityReqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.setSecurityReqId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string security_response_id = 4;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getSecurityResponseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.setSecurityResponseId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional SecurityResponseTypeEnum security_response_type = 5;
 * @return {!proto.SecuritiesReferenceData.SecurityResponseTypeEnum}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getSecurityResponseType = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityResponseTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityResponseTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.setSecurityResponseType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional Session.StandardHeader standard_header = 6;
 * @return {?proto.Session.StandardHeader}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 6));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
*/
proto.SecuritiesReferenceData.SecurityTypes.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 7;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 7));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
*/
proto.SecuritiesReferenceData.SecurityTypes.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional SubscriptionRequestTypeEnum subscription_request_type = 8;
 * @return {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getSubscriptionRequestType = function() {
  return /** @type {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.setSubscriptionRequestType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string text = 9;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional sfixed64 tot_no_security_types = 10;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getTotNoSecurityTypes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.setTotNoSecurityTypes = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional TradingSessionIDEnum trading_session_id = 11;
 * @return {!proto.SecuritiesReferenceData.TradingSessionIDEnum}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getTradingSessionId = function() {
  return /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.TradingSessionIDEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setOneofField(this, 11, proto.SecuritiesReferenceData.SecurityTypes.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.clearTradingSessionId = function() {
  return jspb.Message.setOneofField(this, 11, proto.SecuritiesReferenceData.SecurityTypes.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.hasTradingSessionId = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional fixed32 trading_session_id_reserved100plus = 12;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getTradingSessionIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.setTradingSessionIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 12, proto.SecuritiesReferenceData.SecurityTypes.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.clearTradingSessionIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 12, proto.SecuritiesReferenceData.SecurityTypes.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.hasTradingSessionIdReserved100plus = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional TradingSessionSubIDEnum trading_session_sub_id = 13;
 * @return {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getTradingSessionSubId = function() {
  return /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.setTradingSessionSubId = function(value) {
  return jspb.Message.setOneofField(this, 13, proto.SecuritiesReferenceData.SecurityTypes.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.clearTradingSessionSubId = function() {
  return jspb.Message.setOneofField(this, 13, proto.SecuritiesReferenceData.SecurityTypes.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.hasTradingSessionSubId = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional fixed32 trading_session_sub_id_reserved100plus = 14;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getTradingSessionSubIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.setTradingSessionSubIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 14, proto.SecuritiesReferenceData.SecurityTypes.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.clearTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 14, proto.SecuritiesReferenceData.SecurityTypes.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.hasTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional bool last_fragment = 15;
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getLastFragment = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.setLastFragment = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * repeated SecTypesGrp sec_types_grp = 16;
 * @return {!Array<!proto.SecuritiesReferenceData.SecTypesGrp>}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getSecTypesGrpList = function() {
  return /** @type{!Array<!proto.SecuritiesReferenceData.SecTypesGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.SecuritiesReferenceData.SecTypesGrp, 16));
};


/**
 * @param {!Array<!proto.SecuritiesReferenceData.SecTypesGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
*/
proto.SecuritiesReferenceData.SecurityTypes.prototype.setSecTypesGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.SecuritiesReferenceData.SecTypesGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.SecuritiesReferenceData.SecTypesGrp}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.addSecTypesGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.SecuritiesReferenceData.SecTypesGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.clearSecTypesGrpList = function() {
  return this.setSecTypesGrpList([]);
};


/**
 * optional Common.ApplicationSequenceControl application_sequence_control = 17;
 * @return {?proto.Common.ApplicationSequenceControl}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getApplicationSequenceControl = function() {
  return /** @type{?proto.Common.ApplicationSequenceControl} */ (
    jspb.Message.getWrapperField(this, common_pb.ApplicationSequenceControl, 17));
};


/**
 * @param {?proto.Common.ApplicationSequenceControl|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
*/
proto.SecuritiesReferenceData.SecurityTypes.prototype.setApplicationSequenceControl = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.clearApplicationSequenceControl = function() {
  return this.setApplicationSequenceControl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.hasApplicationSequenceControl = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional string market_id = 18;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string market_segment_id = 19;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.getMarketSegmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityTypes} returns this
 */
proto.SecuritiesReferenceData.SecurityTypes.prototype.setMarketSegmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SecuritiesReferenceData.SecurityListRequest.repeatedFields_ = [16,18];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_ = [[11,12],[13,14],[22,23],[24,25]];

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityListRequest.TradingSessionIdUnionCase = {
  TRADING_SESSION_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_ID: 11,
  TRADING_SESSION_ID_RESERVED100PLUS: 12
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityListRequest.TradingSessionIdUnionCase}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getTradingSessionIdUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityListRequest.TradingSessionIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityListRequest.TradingSessionSubIdUnionCase = {
  TRADING_SESSION_SUB_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_SUB_ID: 13,
  TRADING_SESSION_SUB_ID_RESERVED100PLUS: 14
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityListRequest.TradingSessionSubIdUnionCase}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getTradingSessionSubIdUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityListRequest.TradingSessionSubIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[1]));
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityListRequest.SecurityListTypeUnionCase = {
  SECURITY_LIST_TYPE_UNION_NOT_SET: 0,
  SECURITY_LIST_TYPE: 22,
  SECURITY_LIST_TYPE_RESERVED100PLUS: 23
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityListRequest.SecurityListTypeUnionCase}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getSecurityListTypeUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityListRequest.SecurityListTypeUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[2]));
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityListRequest.SecurityListTypeSourceUnionCase = {
  SECURITY_LIST_TYPE_SOURCE_UNION_NOT_SET: 0,
  SECURITY_LIST_TYPE_SOURCE: 24,
  SECURITY_LIST_TYPE_SOURCE_RESERVED100PLUS: 25
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityListRequest.SecurityListTypeSourceUnionCase}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getSecurityListTypeSourceUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityListRequest.SecurityListTypeSourceUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[3]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.SecuritiesReferenceData.SecurityListRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SecuritiesReferenceData.SecurityListRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityListRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    currency: jspb.Message.getFieldWithDefault(msg, 1, ""),
    encodedText: jspb.Message.getFieldWithDefault(msg, 2, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 3, 0),
    instrument: (f = msg.getInstrument()) && common_pb.Instrument.toObject(includeInstance, f),
    securityListRequestType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    securityReqId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    subscriptionRequestType: jspb.Message.getFieldWithDefault(msg, 9, 0),
    text: jspb.Message.getFieldWithDefault(msg, 10, ""),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 11, 0),
    tradingSessionIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 12, 0),
    tradingSessionSubId: jspb.Message.getFieldWithDefault(msg, 13, 0),
    tradingSessionSubIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 14, 0),
    financingDetails: (f = msg.getFinancingDetails()) && common_pb.FinancingDetails.toObject(includeInstance, f),
    instrmtLegGrpList: jspb.Message.toObjectList(msg.getInstrmtLegGrpList(),
    common_pb.InstrmtLegGrp.toObject, includeInstance),
    instrumentExtension: (f = msg.getInstrumentExtension()) && common_pb.InstrumentExtension.toObject(includeInstance, f),
    undInstrmtGrpList: jspb.Message.toObjectList(msg.getUndInstrmtGrpList(),
    common_pb.UndInstrmtGrp.toObject, includeInstance),
    marketId: jspb.Message.getFieldWithDefault(msg, 19, ""),
    marketSegmentId: jspb.Message.getFieldWithDefault(msg, 20, ""),
    securityListId: jspb.Message.getFieldWithDefault(msg, 21, ""),
    securityListType: jspb.Message.getFieldWithDefault(msg, 22, 0),
    securityListTypeReserved100plus: jspb.Message.getFieldWithDefault(msg, 23, 0),
    securityListTypeSource: jspb.Message.getFieldWithDefault(msg, 24, 0),
    securityListTypeSourceReserved100plus: jspb.Message.getFieldWithDefault(msg, 25, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest}
 */
proto.SecuritiesReferenceData.SecurityListRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SecuritiesReferenceData.SecurityListRequest;
  return proto.SecuritiesReferenceData.SecurityListRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SecuritiesReferenceData.SecurityListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest}
 */
proto.SecuritiesReferenceData.SecurityListRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 4:
      var value = new common_pb.Instrument;
      reader.readMessage(value,common_pb.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 5:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityListRequestTypeEnum} */ (reader.readEnum());
      msg.setSecurityListRequestType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityReqId(value);
      break;
    case 7:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 8:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 9:
      var value = /** @type {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum} */ (reader.readEnum());
      msg.setSubscriptionRequestType(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 11:
      var value = /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionIdReserved100plus(value);
      break;
    case 13:
      var value = /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (reader.readEnum());
      msg.setTradingSessionSubId(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionSubIdReserved100plus(value);
      break;
    case 15:
      var value = new common_pb.FinancingDetails;
      reader.readMessage(value,common_pb.FinancingDetails.deserializeBinaryFromReader);
      msg.setFinancingDetails(value);
      break;
    case 16:
      var value = new common_pb.InstrmtLegGrp;
      reader.readMessage(value,common_pb.InstrmtLegGrp.deserializeBinaryFromReader);
      msg.addInstrmtLegGrp(value);
      break;
    case 17:
      var value = new common_pb.InstrumentExtension;
      reader.readMessage(value,common_pb.InstrumentExtension.deserializeBinaryFromReader);
      msg.setInstrumentExtension(value);
      break;
    case 18:
      var value = new common_pb.UndInstrmtGrp;
      reader.readMessage(value,common_pb.UndInstrmtGrp.deserializeBinaryFromReader);
      msg.addUndInstrmtGrp(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketSegmentId(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityListId(value);
      break;
    case 22:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityListTypeEnum} */ (reader.readEnum());
      msg.setSecurityListType(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSecurityListTypeReserved100plus(value);
      break;
    case 24:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityListTypeSourceEnum} */ (reader.readEnum());
      msg.setSecurityListTypeSource(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSecurityListTypeSourceReserved100plus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SecuritiesReferenceData.SecurityListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SecuritiesReferenceData.SecurityListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityListRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      3,
      f
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Instrument.serializeBinaryToWriter
    );
  }
  f = message.getSecurityListRequestType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getSecurityReqId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getSubscriptionRequestType();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeFixed32(
      12,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeFixed32(
      14,
      f
    );
  }
  f = message.getFinancingDetails();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      common_pb.FinancingDetails.serializeBinaryToWriter
    );
  }
  f = message.getInstrmtLegGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      common_pb.InstrmtLegGrp.serializeBinaryToWriter
    );
  }
  f = message.getInstrumentExtension();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      common_pb.InstrumentExtension.serializeBinaryToWriter
    );
  }
  f = message.getUndInstrmtGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      common_pb.UndInstrmtGrp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getMarketSegmentId();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getSecurityListId();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.SecurityListTypeEnum} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeEnum(
      22,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 23));
  if (f != null) {
    writer.writeFixed32(
      23,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.SecurityListTypeSourceEnum} */ (jspb.Message.getField(message, 24));
  if (f != null) {
    writer.writeEnum(
      24,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 25));
  if (f != null) {
    writer.writeFixed32(
      25,
      f
    );
  }
};


/**
 * optional string currency = 1;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string encoded_text = 2;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional sfixed64 encoded_text_len = 3;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional Common.Instrument instrument = 4;
 * @return {?proto.Common.Instrument}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, common_pb.Instrument, 4));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional SecurityListRequestTypeEnum security_list_request_type = 5;
 * @return {!proto.SecuritiesReferenceData.SecurityListRequestTypeEnum}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getSecurityListRequestType = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityListRequestTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityListRequestTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setSecurityListRequestType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string security_req_id = 6;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getSecurityReqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setSecurityReqId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional Session.StandardHeader standard_header = 7;
 * @return {?proto.Session.StandardHeader}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 7));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 8;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 8));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional SubscriptionRequestTypeEnum subscription_request_type = 9;
 * @return {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getSubscriptionRequestType = function() {
  return /** @type {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setSubscriptionRequestType = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional string text = 10;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional TradingSessionIDEnum trading_session_id = 11;
 * @return {!proto.SecuritiesReferenceData.TradingSessionIDEnum}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getTradingSessionId = function() {
  return /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.TradingSessionIDEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setOneofField(this, 11, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.clearTradingSessionId = function() {
  return jspb.Message.setOneofField(this, 11, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.hasTradingSessionId = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional fixed32 trading_session_id_reserved100plus = 12;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getTradingSessionIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setTradingSessionIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 12, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.clearTradingSessionIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 12, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.hasTradingSessionIdReserved100plus = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional TradingSessionSubIDEnum trading_session_sub_id = 13;
 * @return {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getTradingSessionSubId = function() {
  return /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setTradingSessionSubId = function(value) {
  return jspb.Message.setOneofField(this, 13, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.clearTradingSessionSubId = function() {
  return jspb.Message.setOneofField(this, 13, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.hasTradingSessionSubId = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional fixed32 trading_session_sub_id_reserved100plus = 14;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getTradingSessionSubIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setTradingSessionSubIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 14, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.clearTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 14, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.hasTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional Common.FinancingDetails financing_details = 15;
 * @return {?proto.Common.FinancingDetails}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getFinancingDetails = function() {
  return /** @type{?proto.Common.FinancingDetails} */ (
    jspb.Message.getWrapperField(this, common_pb.FinancingDetails, 15));
};


/**
 * @param {?proto.Common.FinancingDetails|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setFinancingDetails = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.clearFinancingDetails = function() {
  return this.setFinancingDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.hasFinancingDetails = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * repeated Common.InstrmtLegGrp instrmt_leg_grp = 16;
 * @return {!Array<!proto.Common.InstrmtLegGrp>}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getInstrmtLegGrpList = function() {
  return /** @type{!Array<!proto.Common.InstrmtLegGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.InstrmtLegGrp, 16));
};


/**
 * @param {!Array<!proto.Common.InstrmtLegGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setInstrmtLegGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.Common.InstrmtLegGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.InstrmtLegGrp}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.addInstrmtLegGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.Common.InstrmtLegGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.clearInstrmtLegGrpList = function() {
  return this.setInstrmtLegGrpList([]);
};


/**
 * optional Common.InstrumentExtension instrument_extension = 17;
 * @return {?proto.Common.InstrumentExtension}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getInstrumentExtension = function() {
  return /** @type{?proto.Common.InstrumentExtension} */ (
    jspb.Message.getWrapperField(this, common_pb.InstrumentExtension, 17));
};


/**
 * @param {?proto.Common.InstrumentExtension|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setInstrumentExtension = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.clearInstrumentExtension = function() {
  return this.setInstrumentExtension(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.hasInstrumentExtension = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * repeated Common.UndInstrmtGrp und_instrmt_grp = 18;
 * @return {!Array<!proto.Common.UndInstrmtGrp>}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getUndInstrmtGrpList = function() {
  return /** @type{!Array<!proto.Common.UndInstrmtGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.UndInstrmtGrp, 18));
};


/**
 * @param {!Array<!proto.Common.UndInstrmtGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
*/
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setUndInstrmtGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.Common.UndInstrmtGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndInstrmtGrp}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.addUndInstrmtGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.Common.UndInstrmtGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.clearUndInstrmtGrpList = function() {
  return this.setUndInstrmtGrpList([]);
};


/**
 * optional string market_id = 19;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string market_segment_id = 20;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getMarketSegmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setMarketSegmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string security_list_id = 21;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getSecurityListId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setSecurityListId = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional SecurityListTypeEnum security_list_type = 22;
 * @return {!proto.SecuritiesReferenceData.SecurityListTypeEnum}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getSecurityListType = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityListTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityListTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setSecurityListType = function(value) {
  return jspb.Message.setOneofField(this, 22, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[2], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.clearSecurityListType = function() {
  return jspb.Message.setOneofField(this, 22, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[2], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.hasSecurityListType = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional fixed32 security_list_type_reserved100plus = 23;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getSecurityListTypeReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setSecurityListTypeReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 23, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[2], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.clearSecurityListTypeReserved100plus = function() {
  return jspb.Message.setOneofField(this, 23, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[2], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.hasSecurityListTypeReserved100plus = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional SecurityListTypeSourceEnum security_list_type_source = 24;
 * @return {!proto.SecuritiesReferenceData.SecurityListTypeSourceEnum}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getSecurityListTypeSource = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityListTypeSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityListTypeSourceEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setSecurityListTypeSource = function(value) {
  return jspb.Message.setOneofField(this, 24, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[3], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.clearSecurityListTypeSource = function() {
  return jspb.Message.setOneofField(this, 24, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[3], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.hasSecurityListTypeSource = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional fixed32 security_list_type_source_reserved100plus = 25;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.getSecurityListTypeSourceReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.setSecurityListTypeSourceReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 25, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[3], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.clearSecurityListTypeSourceReserved100plus = function() {
  return jspb.Message.setOneofField(this, 25, proto.SecuritiesReferenceData.SecurityListRequest.oneofGroups_[3], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListRequest.prototype.hasSecurityListTypeSourceReserved100plus = function() {
  return jspb.Message.getField(this, 25) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SecuritiesReferenceData.SecurityList.repeatedFields_ = [9];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.SecuritiesReferenceData.SecurityList.oneofGroups_ = [[19,20],[21,22]];

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityList.SecurityListTypeUnionCase = {
  SECURITY_LIST_TYPE_UNION_NOT_SET: 0,
  SECURITY_LIST_TYPE: 19,
  SECURITY_LIST_TYPE_RESERVED100PLUS: 20
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityList.SecurityListTypeUnionCase}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getSecurityListTypeUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityList.SecurityListTypeUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityList.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityList.SecurityListTypeSourceUnionCase = {
  SECURITY_LIST_TYPE_SOURCE_UNION_NOT_SET: 0,
  SECURITY_LIST_TYPE_SOURCE: 21,
  SECURITY_LIST_TYPE_SOURCE_RESERVED100PLUS: 22
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityList.SecurityListTypeSourceUnionCase}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getSecurityListTypeSourceUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityList.SecurityListTypeSourceUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityList.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.toObject = function(opt_includeInstance) {
  return proto.SecuritiesReferenceData.SecurityList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SecuritiesReferenceData.SecurityList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityList.toObject = function(includeInstance, msg) {
  var f, obj = {
    securityReqId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    securityRequestResult: jspb.Message.getFieldWithDefault(msg, 2, 0),
    securityResponseId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    totNoRelatedSym: jspb.Message.getFieldWithDefault(msg, 6, 0),
    clearingBusinessDate: jspb.Message.getFieldWithDefault(msg, 7, 0),
    lastFragment: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    secListGrpList: jspb.Message.toObjectList(msg.getSecListGrpList(),
    proto.SecuritiesReferenceData.SecListGrp.toObject, includeInstance),
    securityReportId: jspb.Message.getFieldWithDefault(msg, 10, 0),
    applicationSequenceControl: (f = msg.getApplicationSequenceControl()) && common_pb.ApplicationSequenceControl.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 12, ""),
    marketSegmentId: jspb.Message.getFieldWithDefault(msg, 13, ""),
    encodedSecurityListDesc: jspb.Message.getFieldWithDefault(msg, 14, ""),
    encodedSecurityListDescLen: jspb.Message.getFieldWithDefault(msg, 15, 0),
    securityListDesc: jspb.Message.getFieldWithDefault(msg, 16, ""),
    securityListId: jspb.Message.getFieldWithDefault(msg, 17, ""),
    securityListRefId: jspb.Message.getFieldWithDefault(msg, 18, ""),
    securityListType: jspb.Message.getFieldWithDefault(msg, 19, 0),
    securityListTypeReserved100plus: jspb.Message.getFieldWithDefault(msg, 20, 0),
    securityListTypeSource: jspb.Message.getFieldWithDefault(msg, 21, 0),
    securityListTypeSourceReserved100plus: jspb.Message.getFieldWithDefault(msg, 22, 0),
    transactTime: (f = msg.getTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SecuritiesReferenceData.SecurityList}
 */
proto.SecuritiesReferenceData.SecurityList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SecuritiesReferenceData.SecurityList;
  return proto.SecuritiesReferenceData.SecurityList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SecuritiesReferenceData.SecurityList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SecuritiesReferenceData.SecurityList}
 */
proto.SecuritiesReferenceData.SecurityList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityReqId(value);
      break;
    case 2:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityRequestResultEnum} */ (reader.readEnum());
      msg.setSecurityRequestResult(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityResponseId(value);
      break;
    case 4:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 5:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setTotNoRelatedSym(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setClearingBusinessDate(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLastFragment(value);
      break;
    case 9:
      var value = new proto.SecuritiesReferenceData.SecListGrp;
      reader.readMessage(value,proto.SecuritiesReferenceData.SecListGrp.deserializeBinaryFromReader);
      msg.addSecListGrp(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setSecurityReportId(value);
      break;
    case 11:
      var value = new common_pb.ApplicationSequenceControl;
      reader.readMessage(value,common_pb.ApplicationSequenceControl.deserializeBinaryFromReader);
      msg.setApplicationSequenceControl(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketSegmentId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedSecurityListDesc(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedSecurityListDescLen(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityListDesc(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityListId(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityListRefId(value);
      break;
    case 19:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityListTypeEnum} */ (reader.readEnum());
      msg.setSecurityListType(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSecurityListTypeReserved100plus(value);
      break;
    case 21:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityListTypeSourceEnum} */ (reader.readEnum());
      msg.setSecurityListTypeSource(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSecurityListTypeSourceReserved100plus(value);
      break;
    case 23:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SecuritiesReferenceData.SecurityList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SecuritiesReferenceData.SecurityList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSecurityReqId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSecurityRequestResult();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSecurityResponseId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getTotNoRelatedSym();
  if (f !== 0) {
    writer.writeSfixed64(
      6,
      f
    );
  }
  f = message.getClearingBusinessDate();
  if (f !== 0) {
    writer.writeSfixed32(
      7,
      f
    );
  }
  f = message.getLastFragment();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getSecListGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.SecuritiesReferenceData.SecListGrp.serializeBinaryToWriter
    );
  }
  f = message.getSecurityReportId();
  if (f !== 0) {
    writer.writeSfixed64(
      10,
      f
    );
  }
  f = message.getApplicationSequenceControl();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      common_pb.ApplicationSequenceControl.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getMarketSegmentId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getEncodedSecurityListDesc();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getEncodedSecurityListDescLen();
  if (f !== 0) {
    writer.writeSfixed64(
      15,
      f
    );
  }
  f = message.getSecurityListDesc();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getSecurityListId();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getSecurityListRefId();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.SecurityListTypeEnum} */ (jspb.Message.getField(message, 19));
  if (f != null) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 20));
  if (f != null) {
    writer.writeFixed32(
      20,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.SecurityListTypeSourceEnum} */ (jspb.Message.getField(message, 21));
  if (f != null) {
    writer.writeEnum(
      21,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeFixed32(
      22,
      f
    );
  }
  f = message.getTransactTime();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string security_req_id = 1;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getSecurityReqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.setSecurityReqId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SecurityRequestResultEnum security_request_result = 2;
 * @return {!proto.SecuritiesReferenceData.SecurityRequestResultEnum}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getSecurityRequestResult = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityRequestResultEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityRequestResultEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.setSecurityRequestResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string security_response_id = 3;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getSecurityResponseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.setSecurityResponseId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Session.StandardHeader standard_header = 4;
 * @return {?proto.Session.StandardHeader}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 4));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
*/
proto.SecuritiesReferenceData.SecurityList.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 5;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 5));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
*/
proto.SecuritiesReferenceData.SecurityList.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional sfixed64 tot_no_related_sym = 6;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getTotNoRelatedSym = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.setTotNoRelatedSym = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional sfixed32 clearing_business_date = 7;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getClearingBusinessDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.setClearingBusinessDate = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional bool last_fragment = 8;
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getLastFragment = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.setLastFragment = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * repeated SecListGrp sec_list_grp = 9;
 * @return {!Array<!proto.SecuritiesReferenceData.SecListGrp>}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getSecListGrpList = function() {
  return /** @type{!Array<!proto.SecuritiesReferenceData.SecListGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.SecuritiesReferenceData.SecListGrp, 9));
};


/**
 * @param {!Array<!proto.SecuritiesReferenceData.SecListGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
*/
proto.SecuritiesReferenceData.SecurityList.prototype.setSecListGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.SecuritiesReferenceData.SecListGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.SecuritiesReferenceData.SecListGrp}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.addSecListGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.SecuritiesReferenceData.SecListGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.clearSecListGrpList = function() {
  return this.setSecListGrpList([]);
};


/**
 * optional sfixed64 security_report_id = 10;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getSecurityReportId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.setSecurityReportId = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional Common.ApplicationSequenceControl application_sequence_control = 11;
 * @return {?proto.Common.ApplicationSequenceControl}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getApplicationSequenceControl = function() {
  return /** @type{?proto.Common.ApplicationSequenceControl} */ (
    jspb.Message.getWrapperField(this, common_pb.ApplicationSequenceControl, 11));
};


/**
 * @param {?proto.Common.ApplicationSequenceControl|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
*/
proto.SecuritiesReferenceData.SecurityList.prototype.setApplicationSequenceControl = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.clearApplicationSequenceControl = function() {
  return this.setApplicationSequenceControl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.hasApplicationSequenceControl = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string market_id = 12;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string market_segment_id = 13;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getMarketSegmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.setMarketSegmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string encoded_security_list_desc = 14;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getEncodedSecurityListDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.setEncodedSecurityListDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional sfixed64 encoded_security_list_desc_len = 15;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getEncodedSecurityListDescLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.setEncodedSecurityListDescLen = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string security_list_desc = 16;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getSecurityListDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.setSecurityListDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string security_list_id = 17;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getSecurityListId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.setSecurityListId = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string security_list_ref_id = 18;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getSecurityListRefId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.setSecurityListRefId = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional SecurityListTypeEnum security_list_type = 19;
 * @return {!proto.SecuritiesReferenceData.SecurityListTypeEnum}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getSecurityListType = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityListTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityListTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.setSecurityListType = function(value) {
  return jspb.Message.setOneofField(this, 19, proto.SecuritiesReferenceData.SecurityList.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.clearSecurityListType = function() {
  return jspb.Message.setOneofField(this, 19, proto.SecuritiesReferenceData.SecurityList.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.hasSecurityListType = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional fixed32 security_list_type_reserved100plus = 20;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getSecurityListTypeReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.setSecurityListTypeReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 20, proto.SecuritiesReferenceData.SecurityList.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.clearSecurityListTypeReserved100plus = function() {
  return jspb.Message.setOneofField(this, 20, proto.SecuritiesReferenceData.SecurityList.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.hasSecurityListTypeReserved100plus = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional SecurityListTypeSourceEnum security_list_type_source = 21;
 * @return {!proto.SecuritiesReferenceData.SecurityListTypeSourceEnum}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getSecurityListTypeSource = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityListTypeSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityListTypeSourceEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.setSecurityListTypeSource = function(value) {
  return jspb.Message.setOneofField(this, 21, proto.SecuritiesReferenceData.SecurityList.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.clearSecurityListTypeSource = function() {
  return jspb.Message.setOneofField(this, 21, proto.SecuritiesReferenceData.SecurityList.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.hasSecurityListTypeSource = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional fixed32 security_list_type_source_reserved100plus = 22;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getSecurityListTypeSourceReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.setSecurityListTypeSourceReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 22, proto.SecuritiesReferenceData.SecurityList.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.clearSecurityListTypeSourceReserved100plus = function() {
  return jspb.Message.setOneofField(this, 22, proto.SecuritiesReferenceData.SecurityList.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.hasSecurityListTypeSourceReserved100plus = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional fix.Timestamp transact_time = 23;
 * @return {?proto.fix.Timestamp}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.getTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 23));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
*/
proto.SecuritiesReferenceData.SecurityList.prototype.setTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityList} returns this
 */
proto.SecuritiesReferenceData.SecurityList.prototype.clearTransactTime = function() {
  return this.setTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityList.prototype.hasTransactTime = function() {
  return jspb.Message.getField(this, 23) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.oneofGroups_ = [[10,11],[12,13]];

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.TradingSessionIdUnionCase = {
  TRADING_SESSION_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_ID: 10,
  TRADING_SESSION_ID_RESERVED100PLUS: 11
};

/**
 * @return {proto.SecuritiesReferenceData.DerivativeSecurityListRequest.TradingSessionIdUnionCase}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getTradingSessionIdUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.DerivativeSecurityListRequest.TradingSessionIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.DerivativeSecurityListRequest.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.TradingSessionSubIdUnionCase = {
  TRADING_SESSION_SUB_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_SUB_ID: 12,
  TRADING_SESSION_SUB_ID_RESERVED100PLUS: 13
};

/**
 * @return {proto.SecuritiesReferenceData.DerivativeSecurityListRequest.TradingSessionSubIdUnionCase}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getTradingSessionSubIdUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.DerivativeSecurityListRequest.TradingSessionSubIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.DerivativeSecurityListRequest.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.SecuritiesReferenceData.DerivativeSecurityListRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    currency: jspb.Message.getFieldWithDefault(msg, 1, ""),
    encodedText: jspb.Message.getFieldWithDefault(msg, 2, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 3, 0),
    securityListRequestType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    securityReqId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    subscriptionRequestType: jspb.Message.getFieldWithDefault(msg, 8, 0),
    text: jspb.Message.getFieldWithDefault(msg, 9, ""),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 10, 0),
    tradingSessionIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 11, 0),
    tradingSessionSubId: jspb.Message.getFieldWithDefault(msg, 12, 0),
    tradingSessionSubIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 13, 0),
    underlyingInstrument: (f = msg.getUnderlyingInstrument()) && common_pb.UnderlyingInstrument.toObject(includeInstance, f),
    securitySubType: jspb.Message.getFieldWithDefault(msg, 15, ""),
    derivativeInstrument: (f = msg.getDerivativeInstrument()) && common_pb.DerivativeInstrument.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 17, ""),
    marketSegmentId: jspb.Message.getFieldWithDefault(msg, 18, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SecuritiesReferenceData.DerivativeSecurityListRequest;
  return proto.SecuritiesReferenceData.DerivativeSecurityListRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 4:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityListRequestTypeEnum} */ (reader.readEnum());
      msg.setSecurityListRequestType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityReqId(value);
      break;
    case 6:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 7:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 8:
      var value = /** @type {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum} */ (reader.readEnum());
      msg.setSubscriptionRequestType(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 10:
      var value = /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionIdReserved100plus(value);
      break;
    case 12:
      var value = /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (reader.readEnum());
      msg.setTradingSessionSubId(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionSubIdReserved100plus(value);
      break;
    case 14:
      var value = new common_pb.UnderlyingInstrument;
      reader.readMessage(value,common_pb.UnderlyingInstrument.deserializeBinaryFromReader);
      msg.setUnderlyingInstrument(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecuritySubType(value);
      break;
    case 16:
      var value = new common_pb.DerivativeInstrument;
      reader.readMessage(value,common_pb.DerivativeInstrument.deserializeBinaryFromReader);
      msg.setDerivativeInstrument(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketSegmentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SecuritiesReferenceData.DerivativeSecurityListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      3,
      f
    );
  }
  f = message.getSecurityListRequestType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getSecurityReqId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getSubscriptionRequestType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeFixed32(
      11,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeFixed32(
      13,
      f
    );
  }
  f = message.getUnderlyingInstrument();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      common_pb.UnderlyingInstrument.serializeBinaryToWriter
    );
  }
  f = message.getSecuritySubType();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getDerivativeInstrument();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      common_pb.DerivativeInstrument.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getMarketSegmentId();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
};


/**
 * optional string currency = 1;
 * @return {string}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string encoded_text = 2;
 * @return {string}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional sfixed64 encoded_text_len = 3;
 * @return {number}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional SecurityListRequestTypeEnum security_list_request_type = 4;
 * @return {!proto.SecuritiesReferenceData.SecurityListRequestTypeEnum}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getSecurityListRequestType = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityListRequestTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityListRequestTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.setSecurityListRequestType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string security_req_id = 5;
 * @return {string}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getSecurityReqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.setSecurityReqId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Session.StandardHeader standard_header = 6;
 * @return {?proto.Session.StandardHeader}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 6));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
*/
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 7;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 7));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
*/
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional SubscriptionRequestTypeEnum subscription_request_type = 8;
 * @return {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getSubscriptionRequestType = function() {
  return /** @type {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.setSubscriptionRequestType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string text = 9;
 * @return {string}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional TradingSessionIDEnum trading_session_id = 10;
 * @return {!proto.SecuritiesReferenceData.TradingSessionIDEnum}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getTradingSessionId = function() {
  return /** @type {!proto.SecuritiesReferenceData.TradingSessionIDEnum} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.TradingSessionIDEnum} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setOneofField(this, 10, proto.SecuritiesReferenceData.DerivativeSecurityListRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.clearTradingSessionId = function() {
  return jspb.Message.setOneofField(this, 10, proto.SecuritiesReferenceData.DerivativeSecurityListRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.hasTradingSessionId = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional fixed32 trading_session_id_reserved100plus = 11;
 * @return {number}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getTradingSessionIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.setTradingSessionIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 11, proto.SecuritiesReferenceData.DerivativeSecurityListRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.clearTradingSessionIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 11, proto.SecuritiesReferenceData.DerivativeSecurityListRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.hasTradingSessionIdReserved100plus = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional TradingSessionSubIDEnum trading_session_sub_id = 12;
 * @return {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getTradingSessionSubId = function() {
  return /** @type {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.TradingSessionSubIDEnum} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.setTradingSessionSubId = function(value) {
  return jspb.Message.setOneofField(this, 12, proto.SecuritiesReferenceData.DerivativeSecurityListRequest.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.clearTradingSessionSubId = function() {
  return jspb.Message.setOneofField(this, 12, proto.SecuritiesReferenceData.DerivativeSecurityListRequest.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.hasTradingSessionSubId = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional fixed32 trading_session_sub_id_reserved100plus = 13;
 * @return {number}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getTradingSessionSubIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.setTradingSessionSubIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 13, proto.SecuritiesReferenceData.DerivativeSecurityListRequest.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.clearTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 13, proto.SecuritiesReferenceData.DerivativeSecurityListRequest.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.hasTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional Common.UnderlyingInstrument underlying_instrument = 14;
 * @return {?proto.Common.UnderlyingInstrument}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getUnderlyingInstrument = function() {
  return /** @type{?proto.Common.UnderlyingInstrument} */ (
    jspb.Message.getWrapperField(this, common_pb.UnderlyingInstrument, 14));
};


/**
 * @param {?proto.Common.UnderlyingInstrument|undefined} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
*/
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.setUnderlyingInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.clearUnderlyingInstrument = function() {
  return this.setUnderlyingInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.hasUnderlyingInstrument = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string security_sub_type = 15;
 * @return {string}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getSecuritySubType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.setSecuritySubType = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional Common.DerivativeInstrument derivative_instrument = 16;
 * @return {?proto.Common.DerivativeInstrument}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getDerivativeInstrument = function() {
  return /** @type{?proto.Common.DerivativeInstrument} */ (
    jspb.Message.getWrapperField(this, common_pb.DerivativeInstrument, 16));
};


/**
 * @param {?proto.Common.DerivativeInstrument|undefined} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
*/
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.setDerivativeInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.clearDerivativeInstrument = function() {
  return this.setDerivativeInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.hasDerivativeInstrument = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string market_id = 17;
 * @return {string}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string market_segment_id = 18;
 * @return {string}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.getMarketSegmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListRequest} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListRequest.prototype.setMarketSegmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.toObject = function(opt_includeInstance) {
  return proto.SecuritiesReferenceData.DerivativeSecurityList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SecuritiesReferenceData.DerivativeSecurityList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.toObject = function(includeInstance, msg) {
  var f, obj = {
    securityReqId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    securityRequestResult: jspb.Message.getFieldWithDefault(msg, 2, 0),
    securityResponseId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    totNoRelatedSym: jspb.Message.getFieldWithDefault(msg, 6, 0),
    underlyingInstrument: (f = msg.getUnderlyingInstrument()) && common_pb.UnderlyingInstrument.toObject(includeInstance, f),
    lastFragment: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    relSymDerivSecGrpList: jspb.Message.toObjectList(msg.getRelSymDerivSecGrpList(),
    proto.SecuritiesReferenceData.RelSymDerivSecGrp.toObject, includeInstance),
    applicationSequenceControl: (f = msg.getApplicationSequenceControl()) && common_pb.ApplicationSequenceControl.toObject(includeInstance, f),
    derivativeSecurityDefinition: (f = msg.getDerivativeSecurityDefinition()) && common_pb.DerivativeSecurityDefinition.toObject(includeInstance, f),
    clearingBusinessDate: jspb.Message.getFieldWithDefault(msg, 12, 0),
    securityReportId: jspb.Message.getFieldWithDefault(msg, 13, 0),
    transactTime: (f = msg.getTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SecuritiesReferenceData.DerivativeSecurityList;
  return proto.SecuritiesReferenceData.DerivativeSecurityList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SecuritiesReferenceData.DerivativeSecurityList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityReqId(value);
      break;
    case 2:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityRequestResultEnum} */ (reader.readEnum());
      msg.setSecurityRequestResult(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityResponseId(value);
      break;
    case 4:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 5:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setTotNoRelatedSym(value);
      break;
    case 7:
      var value = new common_pb.UnderlyingInstrument;
      reader.readMessage(value,common_pb.UnderlyingInstrument.deserializeBinaryFromReader);
      msg.setUnderlyingInstrument(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLastFragment(value);
      break;
    case 9:
      var value = new proto.SecuritiesReferenceData.RelSymDerivSecGrp;
      reader.readMessage(value,proto.SecuritiesReferenceData.RelSymDerivSecGrp.deserializeBinaryFromReader);
      msg.addRelSymDerivSecGrp(value);
      break;
    case 10:
      var value = new common_pb.ApplicationSequenceControl;
      reader.readMessage(value,common_pb.ApplicationSequenceControl.deserializeBinaryFromReader);
      msg.setApplicationSequenceControl(value);
      break;
    case 11:
      var value = new common_pb.DerivativeSecurityDefinition;
      reader.readMessage(value,common_pb.DerivativeSecurityDefinition.deserializeBinaryFromReader);
      msg.setDerivativeSecurityDefinition(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setClearingBusinessDate(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setSecurityReportId(value);
      break;
    case 14:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SecuritiesReferenceData.DerivativeSecurityList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SecuritiesReferenceData.DerivativeSecurityList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSecurityReqId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSecurityRequestResult();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSecurityResponseId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getTotNoRelatedSym();
  if (f !== 0) {
    writer.writeSfixed64(
      6,
      f
    );
  }
  f = message.getUnderlyingInstrument();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      common_pb.UnderlyingInstrument.serializeBinaryToWriter
    );
  }
  f = message.getLastFragment();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getRelSymDerivSecGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.SecuritiesReferenceData.RelSymDerivSecGrp.serializeBinaryToWriter
    );
  }
  f = message.getApplicationSequenceControl();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      common_pb.ApplicationSequenceControl.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeSecurityDefinition();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      common_pb.DerivativeSecurityDefinition.serializeBinaryToWriter
    );
  }
  f = message.getClearingBusinessDate();
  if (f !== 0) {
    writer.writeSfixed32(
      12,
      f
    );
  }
  f = message.getSecurityReportId();
  if (f !== 0) {
    writer.writeSfixed64(
      13,
      f
    );
  }
  f = message.getTransactTime();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string security_req_id = 1;
 * @return {string}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.getSecurityReqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.setSecurityReqId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SecurityRequestResultEnum security_request_result = 2;
 * @return {!proto.SecuritiesReferenceData.SecurityRequestResultEnum}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.getSecurityRequestResult = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityRequestResultEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityRequestResultEnum} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.setSecurityRequestResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string security_response_id = 3;
 * @return {string}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.getSecurityResponseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.setSecurityResponseId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Session.StandardHeader standard_header = 4;
 * @return {?proto.Session.StandardHeader}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 4));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
*/
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 5;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 5));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
*/
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional sfixed64 tot_no_related_sym = 6;
 * @return {number}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.getTotNoRelatedSym = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.setTotNoRelatedSym = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional Common.UnderlyingInstrument underlying_instrument = 7;
 * @return {?proto.Common.UnderlyingInstrument}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.getUnderlyingInstrument = function() {
  return /** @type{?proto.Common.UnderlyingInstrument} */ (
    jspb.Message.getWrapperField(this, common_pb.UnderlyingInstrument, 7));
};


/**
 * @param {?proto.Common.UnderlyingInstrument|undefined} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
*/
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.setUnderlyingInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.clearUnderlyingInstrument = function() {
  return this.setUnderlyingInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.hasUnderlyingInstrument = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool last_fragment = 8;
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.getLastFragment = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.setLastFragment = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * repeated RelSymDerivSecGrp rel_sym_deriv_sec_grp = 9;
 * @return {!Array<!proto.SecuritiesReferenceData.RelSymDerivSecGrp>}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.getRelSymDerivSecGrpList = function() {
  return /** @type{!Array<!proto.SecuritiesReferenceData.RelSymDerivSecGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.SecuritiesReferenceData.RelSymDerivSecGrp, 9));
};


/**
 * @param {!Array<!proto.SecuritiesReferenceData.RelSymDerivSecGrp>} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
*/
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.setRelSymDerivSecGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.SecuritiesReferenceData.RelSymDerivSecGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.SecuritiesReferenceData.RelSymDerivSecGrp}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.addRelSymDerivSecGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.SecuritiesReferenceData.RelSymDerivSecGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.clearRelSymDerivSecGrpList = function() {
  return this.setRelSymDerivSecGrpList([]);
};


/**
 * optional Common.ApplicationSequenceControl application_sequence_control = 10;
 * @return {?proto.Common.ApplicationSequenceControl}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.getApplicationSequenceControl = function() {
  return /** @type{?proto.Common.ApplicationSequenceControl} */ (
    jspb.Message.getWrapperField(this, common_pb.ApplicationSequenceControl, 10));
};


/**
 * @param {?proto.Common.ApplicationSequenceControl|undefined} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
*/
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.setApplicationSequenceControl = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.clearApplicationSequenceControl = function() {
  return this.setApplicationSequenceControl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.hasApplicationSequenceControl = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional Common.DerivativeSecurityDefinition derivative_security_definition = 11;
 * @return {?proto.Common.DerivativeSecurityDefinition}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.getDerivativeSecurityDefinition = function() {
  return /** @type{?proto.Common.DerivativeSecurityDefinition} */ (
    jspb.Message.getWrapperField(this, common_pb.DerivativeSecurityDefinition, 11));
};


/**
 * @param {?proto.Common.DerivativeSecurityDefinition|undefined} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
*/
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.setDerivativeSecurityDefinition = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.clearDerivativeSecurityDefinition = function() {
  return this.setDerivativeSecurityDefinition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.hasDerivativeSecurityDefinition = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional sfixed32 clearing_business_date = 12;
 * @return {number}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.getClearingBusinessDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.setClearingBusinessDate = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional sfixed64 security_report_id = 13;
 * @return {number}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.getSecurityReportId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.setSecurityReportId = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional fix.Timestamp transact_time = 14;
 * @return {?proto.fix.Timestamp}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.getTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 14));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
*/
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.setTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityList} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.clearTransactTime = function() {
  return this.setTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityList.prototype.hasTransactTime = function() {
  return jspb.Message.getField(this, 14) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.repeatedFields_ = [2,6,18,20,21];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.toObject = function(opt_includeInstance) {
  return proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.toObject = function(includeInstance, msg) {
  var f, obj = {
    clearingBusinessDate: jspb.Message.getFieldWithDefault(msg, 1, 0),
    corporateActionList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    currency: jspb.Message.getFieldWithDefault(msg, 3, ""),
    encodedText: jspb.Message.getFieldWithDefault(msg, 4, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 5, 0),
    instrmtLegGrpList: jspb.Message.toObjectList(msg.getInstrmtLegGrpList(),
    common_pb.InstrmtLegGrp.toObject, includeInstance),
    instrument: (f = msg.getInstrument()) && common_pb.Instrument.toObject(includeInstance, f),
    securityReportId: jspb.Message.getFieldWithDefault(msg, 8, 0),
    securityReqId: jspb.Message.getFieldWithDefault(msg, 9, ""),
    securityResponseId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    securityResponseType: jspb.Message.getFieldWithDefault(msg, 11, 0),
    securityUpdateAction: jspb.Message.getFieldWithDefault(msg, 12, 0),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 15, ""),
    applicationSequenceControl: (f = msg.getApplicationSequenceControl()) && common_pb.ApplicationSequenceControl.toObject(includeInstance, f),
    instrumentExtension: (f = msg.getInstrumentExtension()) && common_pb.InstrumentExtension.toObject(includeInstance, f),
    marketSegmentGrpList: jspb.Message.toObjectList(msg.getMarketSegmentGrpList(),
    common_pb.MarketSegmentGrp.toObject, includeInstance),
    spreadOrBenchmarkCurveData: (f = msg.getSpreadOrBenchmarkCurveData()) && common_pb.SpreadOrBenchmarkCurveData.toObject(includeInstance, f),
    stipulationsList: jspb.Message.toObjectList(msg.getStipulationsList(),
    common_pb.Stipulations.toObject, includeInstance),
    undInstrmtGrpList: jspb.Message.toObjectList(msg.getUndInstrmtGrpList(),
    common_pb.UndInstrmtGrp.toObject, includeInstance),
    yieldData: (f = msg.getYieldData()) && common_pb.YieldData.toObject(includeInstance, f),
    transactTime: (f = msg.getTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport;
  return proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setClearingBusinessDate(value);
      break;
    case 2:
      var values = /** @type {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addCorporateAction(values[i]);
      }
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 6:
      var value = new common_pb.InstrmtLegGrp;
      reader.readMessage(value,common_pb.InstrmtLegGrp.deserializeBinaryFromReader);
      msg.addInstrmtLegGrp(value);
      break;
    case 7:
      var value = new common_pb.Instrument;
      reader.readMessage(value,common_pb.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setSecurityReportId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityReqId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityResponseId(value);
      break;
    case 11:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityResponseTypeEnum} */ (reader.readEnum());
      msg.setSecurityResponseType(value);
      break;
    case 12:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityUpdateActionEnum} */ (reader.readEnum());
      msg.setSecurityUpdateAction(value);
      break;
    case 13:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 14:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 16:
      var value = new common_pb.ApplicationSequenceControl;
      reader.readMessage(value,common_pb.ApplicationSequenceControl.deserializeBinaryFromReader);
      msg.setApplicationSequenceControl(value);
      break;
    case 17:
      var value = new common_pb.InstrumentExtension;
      reader.readMessage(value,common_pb.InstrumentExtension.deserializeBinaryFromReader);
      msg.setInstrumentExtension(value);
      break;
    case 18:
      var value = new common_pb.MarketSegmentGrp;
      reader.readMessage(value,common_pb.MarketSegmentGrp.deserializeBinaryFromReader);
      msg.addMarketSegmentGrp(value);
      break;
    case 19:
      var value = new common_pb.SpreadOrBenchmarkCurveData;
      reader.readMessage(value,common_pb.SpreadOrBenchmarkCurveData.deserializeBinaryFromReader);
      msg.setSpreadOrBenchmarkCurveData(value);
      break;
    case 20:
      var value = new common_pb.Stipulations;
      reader.readMessage(value,common_pb.Stipulations.deserializeBinaryFromReader);
      msg.addStipulations(value);
      break;
    case 21:
      var value = new common_pb.UndInstrmtGrp;
      reader.readMessage(value,common_pb.UndInstrmtGrp.deserializeBinaryFromReader);
      msg.addUndInstrmtGrp(value);
      break;
    case 22:
      var value = new common_pb.YieldData;
      reader.readMessage(value,common_pb.YieldData.deserializeBinaryFromReader);
      msg.setYieldData(value);
      break;
    case 23:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClearingBusinessDate();
  if (f !== 0) {
    writer.writeSfixed32(
      1,
      f
    );
  }
  f = message.getCorporateActionList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      5,
      f
    );
  }
  f = message.getInstrmtLegGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      common_pb.InstrmtLegGrp.serializeBinaryToWriter
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      common_pb.Instrument.serializeBinaryToWriter
    );
  }
  f = message.getSecurityReportId();
  if (f !== 0) {
    writer.writeSfixed64(
      8,
      f
    );
  }
  f = message.getSecurityReqId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSecurityResponseId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSecurityResponseType();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getSecurityUpdateAction();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getApplicationSequenceControl();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      common_pb.ApplicationSequenceControl.serializeBinaryToWriter
    );
  }
  f = message.getInstrumentExtension();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      common_pb.InstrumentExtension.serializeBinaryToWriter
    );
  }
  f = message.getMarketSegmentGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      common_pb.MarketSegmentGrp.serializeBinaryToWriter
    );
  }
  f = message.getSpreadOrBenchmarkCurveData();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      common_pb.SpreadOrBenchmarkCurveData.serializeBinaryToWriter
    );
  }
  f = message.getStipulationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      20,
      f,
      common_pb.Stipulations.serializeBinaryToWriter
    );
  }
  f = message.getUndInstrmtGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      21,
      f,
      common_pb.UndInstrmtGrp.serializeBinaryToWriter
    );
  }
  f = message.getYieldData();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      common_pb.YieldData.serializeBinaryToWriter
    );
  }
  f = message.getTransactTime();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional sfixed32 clearing_business_date = 1;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getClearingBusinessDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setClearingBusinessDate = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated CorporateActionEnum corporate_action = 2;
 * @return {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getCorporateActionList = function() {
  return /** @type {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setCorporateActionList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.SecuritiesReferenceData.CorporateActionEnum} value
 * @param {number=} opt_index
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.addCorporateAction = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.clearCorporateActionList = function() {
  return this.setCorporateActionList([]);
};


/**
 * optional string currency = 3;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string encoded_text = 4;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional sfixed64 encoded_text_len = 5;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated Common.InstrmtLegGrp instrmt_leg_grp = 6;
 * @return {!Array<!proto.Common.InstrmtLegGrp>}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getInstrmtLegGrpList = function() {
  return /** @type{!Array<!proto.Common.InstrmtLegGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.InstrmtLegGrp, 6));
};


/**
 * @param {!Array<!proto.Common.InstrmtLegGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setInstrmtLegGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.Common.InstrmtLegGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.InstrmtLegGrp}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.addInstrmtLegGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.Common.InstrmtLegGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.clearInstrmtLegGrpList = function() {
  return this.setInstrmtLegGrpList([]);
};


/**
 * optional Common.Instrument instrument = 7;
 * @return {?proto.Common.Instrument}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, common_pb.Instrument, 7));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional sfixed64 security_report_id = 8;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getSecurityReportId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setSecurityReportId = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string security_req_id = 9;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getSecurityReqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setSecurityReqId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string security_response_id = 10;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getSecurityResponseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setSecurityResponseId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional SecurityResponseTypeEnum security_response_type = 11;
 * @return {!proto.SecuritiesReferenceData.SecurityResponseTypeEnum}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getSecurityResponseType = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityResponseTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityResponseTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setSecurityResponseType = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional SecurityUpdateActionEnum security_update_action = 12;
 * @return {!proto.SecuritiesReferenceData.SecurityUpdateActionEnum}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getSecurityUpdateAction = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityUpdateActionEnum} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityUpdateActionEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setSecurityUpdateAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional Session.StandardHeader standard_header = 13;
 * @return {?proto.Session.StandardHeader}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 13));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 14;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 14));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string text = 15;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional Common.ApplicationSequenceControl application_sequence_control = 16;
 * @return {?proto.Common.ApplicationSequenceControl}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getApplicationSequenceControl = function() {
  return /** @type{?proto.Common.ApplicationSequenceControl} */ (
    jspb.Message.getWrapperField(this, common_pb.ApplicationSequenceControl, 16));
};


/**
 * @param {?proto.Common.ApplicationSequenceControl|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setApplicationSequenceControl = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.clearApplicationSequenceControl = function() {
  return this.setApplicationSequenceControl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.hasApplicationSequenceControl = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional Common.InstrumentExtension instrument_extension = 17;
 * @return {?proto.Common.InstrumentExtension}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getInstrumentExtension = function() {
  return /** @type{?proto.Common.InstrumentExtension} */ (
    jspb.Message.getWrapperField(this, common_pb.InstrumentExtension, 17));
};


/**
 * @param {?proto.Common.InstrumentExtension|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setInstrumentExtension = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.clearInstrumentExtension = function() {
  return this.setInstrumentExtension(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.hasInstrumentExtension = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * repeated Common.MarketSegmentGrp market_segment_grp = 18;
 * @return {!Array<!proto.Common.MarketSegmentGrp>}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getMarketSegmentGrpList = function() {
  return /** @type{!Array<!proto.Common.MarketSegmentGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.MarketSegmentGrp, 18));
};


/**
 * @param {!Array<!proto.Common.MarketSegmentGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setMarketSegmentGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.Common.MarketSegmentGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.MarketSegmentGrp}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.addMarketSegmentGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.Common.MarketSegmentGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.clearMarketSegmentGrpList = function() {
  return this.setMarketSegmentGrpList([]);
};


/**
 * optional Common.SpreadOrBenchmarkCurveData spread_or_benchmark_curve_data = 19;
 * @return {?proto.Common.SpreadOrBenchmarkCurveData}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getSpreadOrBenchmarkCurveData = function() {
  return /** @type{?proto.Common.SpreadOrBenchmarkCurveData} */ (
    jspb.Message.getWrapperField(this, common_pb.SpreadOrBenchmarkCurveData, 19));
};


/**
 * @param {?proto.Common.SpreadOrBenchmarkCurveData|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setSpreadOrBenchmarkCurveData = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.clearSpreadOrBenchmarkCurveData = function() {
  return this.setSpreadOrBenchmarkCurveData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.hasSpreadOrBenchmarkCurveData = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * repeated Common.Stipulations stipulations = 20;
 * @return {!Array<!proto.Common.Stipulations>}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getStipulationsList = function() {
  return /** @type{!Array<!proto.Common.Stipulations>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Stipulations, 20));
};


/**
 * @param {!Array<!proto.Common.Stipulations>} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setStipulationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 20, value);
};


/**
 * @param {!proto.Common.Stipulations=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.Stipulations}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.addStipulations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 20, opt_value, proto.Common.Stipulations, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.clearStipulationsList = function() {
  return this.setStipulationsList([]);
};


/**
 * repeated Common.UndInstrmtGrp und_instrmt_grp = 21;
 * @return {!Array<!proto.Common.UndInstrmtGrp>}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getUndInstrmtGrpList = function() {
  return /** @type{!Array<!proto.Common.UndInstrmtGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.UndInstrmtGrp, 21));
};


/**
 * @param {!Array<!proto.Common.UndInstrmtGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setUndInstrmtGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 21, value);
};


/**
 * @param {!proto.Common.UndInstrmtGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndInstrmtGrp}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.addUndInstrmtGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.Common.UndInstrmtGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.clearUndInstrmtGrpList = function() {
  return this.setUndInstrmtGrpList([]);
};


/**
 * optional Common.YieldData yield_data = 22;
 * @return {?proto.Common.YieldData}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getYieldData = function() {
  return /** @type{?proto.Common.YieldData} */ (
    jspb.Message.getWrapperField(this, common_pb.YieldData, 22));
};


/**
 * @param {?proto.Common.YieldData|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setYieldData = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.clearYieldData = function() {
  return this.setYieldData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.hasYieldData = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional fix.Timestamp transact_time = 23;
 * @return {?proto.fix.Timestamp}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.getTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 23));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
*/
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.setTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.clearTransactTime = function() {
  return this.setTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityDefinitionUpdateReport.prototype.hasTransactTime = function() {
  return jspb.Message.getField(this, 23) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.repeatedFields_ = [2,4];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.oneofGroups_ = [[21,22],[23,24]];

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.SecurityListTypeUnionCase = {
  SECURITY_LIST_TYPE_UNION_NOT_SET: 0,
  SECURITY_LIST_TYPE: 21,
  SECURITY_LIST_TYPE_RESERVED100PLUS: 22
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityListUpdateReport.SecurityListTypeUnionCase}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getSecurityListTypeUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityListUpdateReport.SecurityListTypeUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityListUpdateReport.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.SecurityListTypeSourceUnionCase = {
  SECURITY_LIST_TYPE_SOURCE_UNION_NOT_SET: 0,
  SECURITY_LIST_TYPE_SOURCE: 23,
  SECURITY_LIST_TYPE_SOURCE_RESERVED100PLUS: 24
};

/**
 * @return {proto.SecuritiesReferenceData.SecurityListUpdateReport.SecurityListTypeSourceUnionCase}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getSecurityListTypeSourceUnionCase = function() {
  return /** @type {proto.SecuritiesReferenceData.SecurityListUpdateReport.SecurityListTypeSourceUnionCase} */(jspb.Message.computeOneofCase(this, proto.SecuritiesReferenceData.SecurityListUpdateReport.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.toObject = function(opt_includeInstance) {
  return proto.SecuritiesReferenceData.SecurityListUpdateReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SecuritiesReferenceData.SecurityListUpdateReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.toObject = function(includeInstance, msg) {
  var f, obj = {
    clearingBusinessDate: jspb.Message.getFieldWithDefault(msg, 1, 0),
    corporateActionList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    lastFragment: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    secLstUpdRelSymGrpList: jspb.Message.toObjectList(msg.getSecLstUpdRelSymGrpList(),
    proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.toObject, includeInstance),
    securityReportId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    securityReqId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    securityRequestResult: jspb.Message.getFieldWithDefault(msg, 7, 0),
    securityResponseId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    securityUpdateAction: jspb.Message.getFieldWithDefault(msg, 9, 0),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    totNoRelatedSym: jspb.Message.getFieldWithDefault(msg, 12, 0),
    applicationSequenceControl: (f = msg.getApplicationSequenceControl()) && common_pb.ApplicationSequenceControl.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 14, ""),
    marketSegmentId: jspb.Message.getFieldWithDefault(msg, 15, ""),
    encodedSecurityListDesc: jspb.Message.getFieldWithDefault(msg, 16, ""),
    encodedSecurityListDescLen: jspb.Message.getFieldWithDefault(msg, 17, 0),
    securityListDesc: jspb.Message.getFieldWithDefault(msg, 18, ""),
    securityListId: jspb.Message.getFieldWithDefault(msg, 19, ""),
    securityListRefId: jspb.Message.getFieldWithDefault(msg, 20, ""),
    securityListType: jspb.Message.getFieldWithDefault(msg, 21, 0),
    securityListTypeReserved100plus: jspb.Message.getFieldWithDefault(msg, 22, 0),
    securityListTypeSource: jspb.Message.getFieldWithDefault(msg, 23, 0),
    securityListTypeSourceReserved100plus: jspb.Message.getFieldWithDefault(msg, 24, 0),
    transactTime: (f = msg.getTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SecuritiesReferenceData.SecurityListUpdateReport;
  return proto.SecuritiesReferenceData.SecurityListUpdateReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SecuritiesReferenceData.SecurityListUpdateReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setClearingBusinessDate(value);
      break;
    case 2:
      var values = /** @type {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addCorporateAction(values[i]);
      }
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLastFragment(value);
      break;
    case 4:
      var value = new proto.SecuritiesReferenceData.SecLstUpdRelSymGrp;
      reader.readMessage(value,proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.deserializeBinaryFromReader);
      msg.addSecLstUpdRelSymGrp(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setSecurityReportId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityReqId(value);
      break;
    case 7:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityRequestResultEnum} */ (reader.readEnum());
      msg.setSecurityRequestResult(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityResponseId(value);
      break;
    case 9:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityUpdateActionEnum} */ (reader.readEnum());
      msg.setSecurityUpdateAction(value);
      break;
    case 10:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 11:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setTotNoRelatedSym(value);
      break;
    case 13:
      var value = new common_pb.ApplicationSequenceControl;
      reader.readMessage(value,common_pb.ApplicationSequenceControl.deserializeBinaryFromReader);
      msg.setApplicationSequenceControl(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketSegmentId(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedSecurityListDesc(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedSecurityListDescLen(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityListDesc(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityListId(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityListRefId(value);
      break;
    case 21:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityListTypeEnum} */ (reader.readEnum());
      msg.setSecurityListType(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSecurityListTypeReserved100plus(value);
      break;
    case 23:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityListTypeSourceEnum} */ (reader.readEnum());
      msg.setSecurityListTypeSource(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSecurityListTypeSourceReserved100plus(value);
      break;
    case 25:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SecuritiesReferenceData.SecurityListUpdateReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SecuritiesReferenceData.SecurityListUpdateReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClearingBusinessDate();
  if (f !== 0) {
    writer.writeSfixed32(
      1,
      f
    );
  }
  f = message.getCorporateActionList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
  f = message.getLastFragment();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getSecLstUpdRelSymGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.SecuritiesReferenceData.SecLstUpdRelSymGrp.serializeBinaryToWriter
    );
  }
  f = message.getSecurityReportId();
  if (f !== 0) {
    writer.writeSfixed64(
      5,
      f
    );
  }
  f = message.getSecurityReqId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSecurityRequestResult();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getSecurityResponseId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSecurityUpdateAction();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getTotNoRelatedSym();
  if (f !== 0) {
    writer.writeSfixed64(
      12,
      f
    );
  }
  f = message.getApplicationSequenceControl();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      common_pb.ApplicationSequenceControl.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getMarketSegmentId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getEncodedSecurityListDesc();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getEncodedSecurityListDescLen();
  if (f !== 0) {
    writer.writeSfixed64(
      17,
      f
    );
  }
  f = message.getSecurityListDesc();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getSecurityListId();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getSecurityListRefId();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.SecurityListTypeEnum} */ (jspb.Message.getField(message, 21));
  if (f != null) {
    writer.writeEnum(
      21,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeFixed32(
      22,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.SecurityListTypeSourceEnum} */ (jspb.Message.getField(message, 23));
  if (f != null) {
    writer.writeEnum(
      23,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 24));
  if (f != null) {
    writer.writeFixed32(
      24,
      f
    );
  }
  f = message.getTransactTime();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional sfixed32 clearing_business_date = 1;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getClearingBusinessDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setClearingBusinessDate = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated CorporateActionEnum corporate_action = 2;
 * @return {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getCorporateActionList = function() {
  return /** @type {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.SecuritiesReferenceData.CorporateActionEnum>} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setCorporateActionList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.SecuritiesReferenceData.CorporateActionEnum} value
 * @param {number=} opt_index
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.addCorporateAction = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.clearCorporateActionList = function() {
  return this.setCorporateActionList([]);
};


/**
 * optional bool last_fragment = 3;
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getLastFragment = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setLastFragment = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated SecLstUpdRelSymGrp sec_lst_upd_rel_sym_grp = 4;
 * @return {!Array<!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp>}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getSecLstUpdRelSymGrpList = function() {
  return /** @type{!Array<!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.SecuritiesReferenceData.SecLstUpdRelSymGrp, 4));
};


/**
 * @param {!Array<!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp>} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
*/
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setSecLstUpdRelSymGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.SecuritiesReferenceData.SecLstUpdRelSymGrp}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.addSecLstUpdRelSymGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.SecuritiesReferenceData.SecLstUpdRelSymGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.clearSecLstUpdRelSymGrpList = function() {
  return this.setSecLstUpdRelSymGrpList([]);
};


/**
 * optional sfixed64 security_report_id = 5;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getSecurityReportId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setSecurityReportId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string security_req_id = 6;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getSecurityReqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setSecurityReqId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional SecurityRequestResultEnum security_request_result = 7;
 * @return {!proto.SecuritiesReferenceData.SecurityRequestResultEnum}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getSecurityRequestResult = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityRequestResultEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityRequestResultEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setSecurityRequestResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string security_response_id = 8;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getSecurityResponseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setSecurityResponseId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional SecurityUpdateActionEnum security_update_action = 9;
 * @return {!proto.SecuritiesReferenceData.SecurityUpdateActionEnum}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getSecurityUpdateAction = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityUpdateActionEnum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityUpdateActionEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setSecurityUpdateAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional Session.StandardHeader standard_header = 10;
 * @return {?proto.Session.StandardHeader}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 10));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
*/
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 11;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 11));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
*/
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional sfixed64 tot_no_related_sym = 12;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getTotNoRelatedSym = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setTotNoRelatedSym = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional Common.ApplicationSequenceControl application_sequence_control = 13;
 * @return {?proto.Common.ApplicationSequenceControl}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getApplicationSequenceControl = function() {
  return /** @type{?proto.Common.ApplicationSequenceControl} */ (
    jspb.Message.getWrapperField(this, common_pb.ApplicationSequenceControl, 13));
};


/**
 * @param {?proto.Common.ApplicationSequenceControl|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
*/
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setApplicationSequenceControl = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.clearApplicationSequenceControl = function() {
  return this.setApplicationSequenceControl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.hasApplicationSequenceControl = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string market_id = 14;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string market_segment_id = 15;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getMarketSegmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setMarketSegmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string encoded_security_list_desc = 16;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getEncodedSecurityListDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setEncodedSecurityListDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional sfixed64 encoded_security_list_desc_len = 17;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getEncodedSecurityListDescLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setEncodedSecurityListDescLen = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional string security_list_desc = 18;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getSecurityListDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setSecurityListDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string security_list_id = 19;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getSecurityListId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setSecurityListId = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string security_list_ref_id = 20;
 * @return {string}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getSecurityListRefId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setSecurityListRefId = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional SecurityListTypeEnum security_list_type = 21;
 * @return {!proto.SecuritiesReferenceData.SecurityListTypeEnum}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getSecurityListType = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityListTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityListTypeEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setSecurityListType = function(value) {
  return jspb.Message.setOneofField(this, 21, proto.SecuritiesReferenceData.SecurityListUpdateReport.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.clearSecurityListType = function() {
  return jspb.Message.setOneofField(this, 21, proto.SecuritiesReferenceData.SecurityListUpdateReport.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.hasSecurityListType = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional fixed32 security_list_type_reserved100plus = 22;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getSecurityListTypeReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setSecurityListTypeReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 22, proto.SecuritiesReferenceData.SecurityListUpdateReport.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.clearSecurityListTypeReserved100plus = function() {
  return jspb.Message.setOneofField(this, 22, proto.SecuritiesReferenceData.SecurityListUpdateReport.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.hasSecurityListTypeReserved100plus = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional SecurityListTypeSourceEnum security_list_type_source = 23;
 * @return {!proto.SecuritiesReferenceData.SecurityListTypeSourceEnum}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getSecurityListTypeSource = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityListTypeSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityListTypeSourceEnum} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setSecurityListTypeSource = function(value) {
  return jspb.Message.setOneofField(this, 23, proto.SecuritiesReferenceData.SecurityListUpdateReport.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.clearSecurityListTypeSource = function() {
  return jspb.Message.setOneofField(this, 23, proto.SecuritiesReferenceData.SecurityListUpdateReport.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.hasSecurityListTypeSource = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional fixed32 security_list_type_source_reserved100plus = 24;
 * @return {number}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getSecurityListTypeSourceReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setSecurityListTypeSourceReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 24, proto.SecuritiesReferenceData.SecurityListUpdateReport.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.clearSecurityListTypeSourceReserved100plus = function() {
  return jspb.Message.setOneofField(this, 24, proto.SecuritiesReferenceData.SecurityListUpdateReport.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.hasSecurityListTypeSourceReserved100plus = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional fix.Timestamp transact_time = 25;
 * @return {?proto.fix.Timestamp}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.getTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 25));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
*/
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.setTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.SecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.clearTransactTime = function() {
  return this.setTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.SecurityListUpdateReport.prototype.hasTransactTime = function() {
  return jspb.Message.getField(this, 25) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.toObject = function(opt_includeInstance) {
  return proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.toObject = function(includeInstance, msg) {
  var f, obj = {
    applicationSequenceControl: (f = msg.getApplicationSequenceControl()) && common_pb.ApplicationSequenceControl.toObject(includeInstance, f),
    derivativeSecurityDefinition: (f = msg.getDerivativeSecurityDefinition()) && common_pb.DerivativeSecurityDefinition.toObject(includeInstance, f),
    lastFragment: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    relSymDerivSecUpdGrpList: jspb.Message.toObjectList(msg.getRelSymDerivSecUpdGrpList(),
    common_pb.RelSymDerivSecUpdGrp.toObject, includeInstance),
    securityReqId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    securityRequestResult: jspb.Message.getFieldWithDefault(msg, 6, 0),
    securityResponseId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    securityUpdateAction: jspb.Message.getFieldWithDefault(msg, 8, 0),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    totNoRelatedSym: jspb.Message.getFieldWithDefault(msg, 11, 0),
    underlyingInstrument: (f = msg.getUnderlyingInstrument()) && common_pb.UnderlyingInstrument.toObject(includeInstance, f),
    transactTime: (f = msg.getTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport;
  return proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.ApplicationSequenceControl;
      reader.readMessage(value,common_pb.ApplicationSequenceControl.deserializeBinaryFromReader);
      msg.setApplicationSequenceControl(value);
      break;
    case 2:
      var value = new common_pb.DerivativeSecurityDefinition;
      reader.readMessage(value,common_pb.DerivativeSecurityDefinition.deserializeBinaryFromReader);
      msg.setDerivativeSecurityDefinition(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLastFragment(value);
      break;
    case 4:
      var value = new common_pb.RelSymDerivSecUpdGrp;
      reader.readMessage(value,common_pb.RelSymDerivSecUpdGrp.deserializeBinaryFromReader);
      msg.addRelSymDerivSecUpdGrp(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityReqId(value);
      break;
    case 6:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityRequestResultEnum} */ (reader.readEnum());
      msg.setSecurityRequestResult(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityResponseId(value);
      break;
    case 8:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityUpdateActionEnum} */ (reader.readEnum());
      msg.setSecurityUpdateAction(value);
      break;
    case 9:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 10:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setTotNoRelatedSym(value);
      break;
    case 12:
      var value = new common_pb.UnderlyingInstrument;
      reader.readMessage(value,common_pb.UnderlyingInstrument.deserializeBinaryFromReader);
      msg.setUnderlyingInstrument(value);
      break;
    case 13:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplicationSequenceControl();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.ApplicationSequenceControl.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeSecurityDefinition();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.DerivativeSecurityDefinition.serializeBinaryToWriter
    );
  }
  f = message.getLastFragment();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getRelSymDerivSecUpdGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      common_pb.RelSymDerivSecUpdGrp.serializeBinaryToWriter
    );
  }
  f = message.getSecurityReqId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSecurityRequestResult();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getSecurityResponseId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSecurityUpdateAction();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getTotNoRelatedSym();
  if (f !== 0) {
    writer.writeSfixed64(
      11,
      f
    );
  }
  f = message.getUnderlyingInstrument();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      common_pb.UnderlyingInstrument.serializeBinaryToWriter
    );
  }
  f = message.getTransactTime();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional Common.ApplicationSequenceControl application_sequence_control = 1;
 * @return {?proto.Common.ApplicationSequenceControl}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.getApplicationSequenceControl = function() {
  return /** @type{?proto.Common.ApplicationSequenceControl} */ (
    jspb.Message.getWrapperField(this, common_pb.ApplicationSequenceControl, 1));
};


/**
 * @param {?proto.Common.ApplicationSequenceControl|undefined} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
*/
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.setApplicationSequenceControl = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.clearApplicationSequenceControl = function() {
  return this.setApplicationSequenceControl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.hasApplicationSequenceControl = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Common.DerivativeSecurityDefinition derivative_security_definition = 2;
 * @return {?proto.Common.DerivativeSecurityDefinition}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.getDerivativeSecurityDefinition = function() {
  return /** @type{?proto.Common.DerivativeSecurityDefinition} */ (
    jspb.Message.getWrapperField(this, common_pb.DerivativeSecurityDefinition, 2));
};


/**
 * @param {?proto.Common.DerivativeSecurityDefinition|undefined} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
*/
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.setDerivativeSecurityDefinition = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.clearDerivativeSecurityDefinition = function() {
  return this.setDerivativeSecurityDefinition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.hasDerivativeSecurityDefinition = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool last_fragment = 3;
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.getLastFragment = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.setLastFragment = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated Common.RelSymDerivSecUpdGrp rel_sym_deriv_sec_upd_grp = 4;
 * @return {!Array<!proto.Common.RelSymDerivSecUpdGrp>}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.getRelSymDerivSecUpdGrpList = function() {
  return /** @type{!Array<!proto.Common.RelSymDerivSecUpdGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.RelSymDerivSecUpdGrp, 4));
};


/**
 * @param {!Array<!proto.Common.RelSymDerivSecUpdGrp>} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
*/
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.setRelSymDerivSecUpdGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Common.RelSymDerivSecUpdGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.RelSymDerivSecUpdGrp}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.addRelSymDerivSecUpdGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Common.RelSymDerivSecUpdGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.clearRelSymDerivSecUpdGrpList = function() {
  return this.setRelSymDerivSecUpdGrpList([]);
};


/**
 * optional string security_req_id = 5;
 * @return {string}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.getSecurityReqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.setSecurityReqId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional SecurityRequestResultEnum security_request_result = 6;
 * @return {!proto.SecuritiesReferenceData.SecurityRequestResultEnum}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.getSecurityRequestResult = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityRequestResultEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityRequestResultEnum} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.setSecurityRequestResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string security_response_id = 7;
 * @return {string}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.getSecurityResponseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.setSecurityResponseId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional SecurityUpdateActionEnum security_update_action = 8;
 * @return {!proto.SecuritiesReferenceData.SecurityUpdateActionEnum}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.getSecurityUpdateAction = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityUpdateActionEnum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityUpdateActionEnum} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.setSecurityUpdateAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional Session.StandardHeader standard_header = 9;
 * @return {?proto.Session.StandardHeader}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 9));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
*/
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 10;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 10));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
*/
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional sfixed64 tot_no_related_sym = 11;
 * @return {number}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.getTotNoRelatedSym = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.setTotNoRelatedSym = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional Common.UnderlyingInstrument underlying_instrument = 12;
 * @return {?proto.Common.UnderlyingInstrument}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.getUnderlyingInstrument = function() {
  return /** @type{?proto.Common.UnderlyingInstrument} */ (
    jspb.Message.getWrapperField(this, common_pb.UnderlyingInstrument, 12));
};


/**
 * @param {?proto.Common.UnderlyingInstrument|undefined} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
*/
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.setUnderlyingInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.clearUnderlyingInstrument = function() {
  return this.setUnderlyingInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.hasUnderlyingInstrument = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional fix.Timestamp transact_time = 13;
 * @return {?proto.fix.Timestamp}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.getTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 13));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
*/
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.setTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport} returns this
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.clearTransactTime = function() {
  return this.setTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SecuritiesReferenceData.DerivativeSecurityListUpdateReport.prototype.hasTransactTime = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.CorporateActionEnum = {
  CORPORATE_ACTION_UNSPECIFIED: 0,
  CORPORATE_ACTION_EX_DISTRIBUTION: 1,
  CORPORATE_ACTION_EX_DIVIDEND: 2,
  CORPORATE_ACTION_EX_INTEREST: 3,
  CORPORATE_ACTION_EX_RIGHTS: 4,
  CORPORATE_ACTION_NEW: 5,
  CORPORATE_ACTION_CASH_DIVIDEND: 6,
  CORPORATE_ACTION_CUSIP: 7,
  CORPORATE_ACTION_LIQUIDATION_REORGANIZATION: 8,
  CORPORATE_ACTION_MERGER_REORGANIZATION: 9,
  CORPORATE_ACTION_NON_INTEGER_STOCK_SPLIT: 10,
  CORPORATE_ACTION_POSITION_CONSOLIDATION: 11,
  CORPORATE_ACTION_REVERSE_STOCK_SPLIT: 12,
  CORPORATE_ACTION_RIGHTS_OFFERING: 13,
  CORPORATE_ACTION_SHAREHOLDER_MEETING: 14,
  CORPORATE_ACTION_SPECIAL_ACTION: 15,
  CORPORATE_ACTION_SPINOFF: 16,
  CORPORATE_ACTION_STANDARD_INTEGER_STOCK_SPLIT: 17,
  CORPORATE_ACTION_STOCK_DIVIDEND: 18,
  CORPORATE_ACTION_SYMBOL_CONVERSION: 19,
  CORPORATE_ACTION_TENDER_OFFER: 20,
  CORPORATE_ACTION_WARRANT: 21,
  CORPORATE_ACTION_LEAP_ROLLOVER: 22,
  CORPORATE_ACTION_SUCCESSION_EVENT: 23
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityTypeEnum = {
  SECURITY_TYPE_UNSPECIFIED: 0,
  SECURITY_TYPE_BANKERS_ACCEPTANCE: 1,
  SECURITY_TYPE_CERTIFICATE_OF_DEPOSIT: 2,
  SECURITY_TYPE_COLLATERALIZED_MORTGAGE_OBLIGATION: 3,
  SECURITY_TYPE_COMMERCIAL_PAPER: 4,
  SECURITY_TYPE_COMMON_STOCK: 5,
  SECURITY_TYPE_CORPORATE_BOND: 6,
  SECURITY_TYPE_CORPORATE_PRIVATE_PLACEMENT: 7,
  SECURITY_TYPE_FOREIGN_EXCHANGE_CONTRACT: 8,
  SECURITY_TYPE_FUTURE: 9,
  SECURITY_TYPE_MISCELLANEOUS_PASS_THROUGH: 10,
  SECURITY_TYPE_MORTGAGE_INTEREST_ONLY: 11,
  SECURITY_TYPE_MORTGAGE_PRINCIPAL_ONLY: 12,
  SECURITY_TYPE_MORTGAGE_PRIVATE_PLACEMENT: 13,
  SECURITY_TYPE_MUTUAL_FUND: 14,
  SECURITY_TYPE_NO_SECURITY_TYPE: 15,
  SECURITY_TYPE_OPTION: 16,
  SECURITY_TYPE_PREFERRED_STOCK: 17,
  SECURITY_TYPE_TIME_DEPOSIT: 18,
  SECURITY_TYPE_US_TREASURY_BILL_OLD: 19,
  SECURITY_TYPE_WARRANT: 20,
  SECURITY_TYPE_CONVERTIBLE_BOND: 21,
  SECURITY_TYPE_IOETTEMORTGAGE: 22,
  SECURITY_TYPE_WILDCARD: 23,
  SECURITY_TYPE_AMENDED: 24,
  SECURITY_TYPE_ASSET_BACKED_SECURITIES: 25,
  SECURITY_TYPE_BANK_NOTES: 26,
  SECURITY_TYPE_BILL_OF_EXCHANGES: 27,
  SECURITY_TYPE_BRADY_BOND: 28,
  SECURITY_TYPE_BRIDGE_LOAN: 29,
  SECURITY_TYPE_CALL_LOANS: 30,
  SECURITY_TYPE_CERTIFICATE_OF_OBLIGATION: 31,
  SECURITY_TYPE_CERTIFICATE_OF_PARTICIPATION: 32,
  SECURITY_TYPE_CORP: 33,
  SECURITY_TYPE_DEBTOR_IN_POSSESSION: 34,
  SECURITY_TYPE_DEFAULTED: 35,
  SECURITY_TYPE_DEPOSIT_NOTES: 36,
  SECURITY_TYPE_DUAL_CURRENCY: 37,
  SECURITY_TYPE_EXTENDED_COMM_NOTE: 38,
  SECURITY_TYPE_FEDERAL_AGENCY_COUPON: 39,
  SECURITY_TYPE_FEDERAL_AGENCY_DISCOUNT_NOTE: 40,
  SECURITY_TYPE_GENERAL_OBLIGATION_BONDS: 41,
  SECURITY_TYPE_INDEXED_LINKED: 42,
  SECURITY_TYPE_INTEREST_STRIP_FROM_ANY_BOND_OR_NOTE: 43,
  SECURITY_TYPE_LETTER_OF_CREDIT: 44,
  SECURITY_TYPE_LIQUIDITY_NOTE: 45,
  SECURITY_TYPE_MANDATORY_TENDER: 46,
  SECURITY_TYPE_MATURED: 47,
  SECURITY_TYPE_MEDIUM_TERM_NOTES: 48,
  SECURITY_TYPE_MORTGAGE_BACKED_SECURITIES: 49,
  SECURITY_TYPE_MULTILEG_INSTRUMENT: 50,
  SECURITY_TYPE_OTHER_ANTICIPATION_NOTES: 51,
  SECURITY_TYPE_OVERNIGHT: 52,
  SECURITY_TYPE_PLAZOS_FIJOS: 53,
  SECURITY_TYPE_PRINCIPAL_STRIP_FROM_ANON_CALLABLE_BOND_OR_NOTE: 54,
  SECURITY_TYPE_PRINCIPAL_STRIP_OF_ACALLABLE_BOND_OR_NOTE: 55,
  SECURITY_TYPE_PRIVATE_EXPORT_FUNDING: 56,
  SECURITY_TYPE_PROMISSORY_NOTE: 57,
  SECURITY_TYPE_REPLACED: 58,
  SECURITY_TYPE_RETIRED: 59,
  SECURITY_TYPE_REVENUE_ANTICIPATION_NOTE: 60,
  SECURITY_TYPE_REVENUE_BONDS: 61,
  SECURITY_TYPE_REVOLVER: 62,
  SECURITY_TYPE_REVOLVER_LOAN: 63,
  SECURITY_TYPE_SHORT_TERM_LOAN_NOTE: 64,
  SECURITY_TYPE_SPECIAL_ASSESSMENT: 65,
  SECURITY_TYPE_SPECIAL_OBLIGATION: 66,
  SECURITY_TYPE_SPECIAL_TAX: 67,
  SECURITY_TYPE_STRUCTURED_NOTES: 68,
  SECURITY_TYPE_SWING_LINE_FACILITY: 69,
  SECURITY_TYPE_TAX_ALLOCATION: 70,
  SECURITY_TYPE_TAX_ANTICIPATION_NOTE: 71,
  SECURITY_TYPE_TAX_EXEMPT_COMMERCIAL_PAPER: 72,
  SECURITY_TYPE_TAX_REVENUE_ANTICIPATION_NOTE: 73,
  SECURITY_TYPE_TERM_LOAN: 74,
  SECURITY_TYPE_TO_BE_ANNOUNCED: 75,
  SECURITY_TYPE_TREASURY_INFLATION_PROTECTED_SECURITIES: 76,
  SECURITY_TYPE_US_TREASURY_BOND: 77,
  SECURITY_TYPE_US_TREASURY_NOTE_OLD: 78,
  SECURITY_TYPE_VARIABLE_RATE_DEMAND_NOTE: 79,
  SECURITY_TYPE_WITHDRAWN: 80,
  SECURITY_TYPE_YANKEE_CORPORATE_BOND: 81,
  SECURITY_TYPE_BUY_SELLBACK: 82,
  SECURITY_TYPE_EURO_CERTIFICATE_OF_DEPOSIT: 83,
  SECURITY_TYPE_EURO_COMMERCIAL_PAPER: 84,
  SECURITY_TYPE_EURO_CORPORATE_BOND: 85,
  SECURITY_TYPE_EURO_SOVEREIGNS: 86,
  SECURITY_TYPE_EURO_SUPRANATIONAL_COUPONS: 87,
  SECURITY_TYPE_FORWARD: 88,
  SECURITY_TYPE_PFANDBRIEFE: 89,
  SECURITY_TYPE_REPURCHASE: 90,
  SECURITY_TYPE_SECURITIES_LOAN: 91,
  SECURITY_TYPE_SECURITIES_PLEDGE: 92,
  SECURITY_TYPE_USD_SUPRANATIONAL_COUPONS: 93,
  SECURITY_TYPE_US_TREASURY_BILL: 94,
  SECURITY_TYPE_US_TREASURY_NOTE: 95,
  SECURITY_TYPE_YANKEE_CERTIFICATE_OF_DEPOSIT: 96,
  SECURITY_TYPE_OPTIONS_ON_FUTURES: 97,
  SECURITY_TYPE_OPTIONS_ON_PHYSICAL: 98,
  SECURITY_TYPE_CASH: 99,
  SECURITY_TYPE_OPTIONS_ON_COMBO: 100,
  SECURITY_TYPE_INTEREST_RATE_SWAP: 101,
  SECURITY_TYPE_BANK_DEPOSITORY_NOTE: 102,
  SECURITY_TYPE_CANADIAN_MONEY_MARKETS: 103,
  SECURITY_TYPE_CANADIAN_MORTGAGE_BONDS: 104,
  SECURITY_TYPE_CANADIAN_PROVINCIAL_BONDS: 105,
  SECURITY_TYPE_CANADIAN_TREASURY_BILLS: 106,
  SECURITY_TYPE_CANADIAN_TREASURY_NOTES: 107,
  SECURITY_TYPE_CREDIT_DEFAULT_SWAP: 108,
  SECURITY_TYPE_EURO_CORPORATE_FLOATING_RATE_NOTES: 109,
  SECURITY_TYPE_SECURED_LIQUIDITY_NOTE: 110,
  SECURITY_TYPE_TAXABLE_MUNICIPAL_CP: 111,
  SECURITY_TYPE_TERM_LIQUIDITY_NOTE: 112,
  SECURITY_TYPE_TREASURY_BILL: 113,
  SECURITY_TYPE_US_CORPORATE_FLOATING_RATE_NOTES: 114,
  SECURITY_TYPE_FX_FORWARD: 115,
  SECURITY_TYPE_FX_SPOT: 116,
  SECURITY_TYPE_FX_SWAP: 117,
  SECURITY_TYPE_NON_DELIVERABLE_FORWARD: 118
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.ProductEnum = {
  PRODUCT_UNSPECIFIED: 0,
  PRODUCT_AGENCY: 1,
  PRODUCT_COMMODITY: 2,
  PRODUCT_CORPORATE: 3,
  PRODUCT_CURRENCY: 4,
  PRODUCT_EQUITY: 5,
  PRODUCT_GOVERNMENT: 6,
  PRODUCT_INDEX: 7,
  PRODUCT_LOAN: 8,
  PRODUCT_MONEYMARKET: 9,
  PRODUCT_MORTGAGE: 10,
  PRODUCT_MUNICIPAL: 11,
  PRODUCT_OTHER: 12,
  PRODUCT_FINANCING: 13
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.ListUpdateActionEnum = {
  LIST_UPDATE_ACTION_UNSPECIFIED: 0,
  LIST_UPDATE_ACTION_ADD: 1,
  LIST_UPDATE_ACTION_DELETE: 2,
  LIST_UPDATE_ACTION_MODIFY: 3
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.LegSwapTypeEnum = {
  LEG_SWAP_TYPE_UNSPECIFIED: 0,
  LEG_SWAP_TYPE_MODIFIED_DURATION: 1,
  LEG_SWAP_TYPE_PAR_FOR_PAR: 2,
  LEG_SWAP_TYPE_PROCEEDS: 3,
  LEG_SWAP_TYPE_RISK: 4
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.LegSettlTypeEnum = {
  LEG_SETTL_TYPE_UNSPECIFIED: 0,
  LEG_SETTL_TYPE_CASH: 1,
  LEG_SETTL_TYPE_FUTURE: 2,
  LEG_SETTL_TYPE_NEXT_DAY: 3,
  LEG_SETTL_TYPE_REGULAR: 4,
  LEG_SETTL_TYPE_SELLERS_OPTION: 5,
  LEG_SETTL_TYPE_TPLUS2: 6,
  LEG_SETTL_TYPE_TPLUS3: 7,
  LEG_SETTL_TYPE_TPLUS4: 8,
  LEG_SETTL_TYPE_WHEN_AND_IF_ISSUED: 9,
  LEG_SETTL_TYPE_TPLUS5: 10,
  LEG_SETTL_TYPE_FX_SPOT_NEXT_SETTLEMENT: 11,
  LEG_SETTL_TYPE_BROKEN_DATE: 12
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityRequestTypeEnum = {
  SECURITY_REQUEST_TYPE_UNSPECIFIED: 0,
  SECURITY_REQUEST_TYPE_REQUEST_LIST_SECURITIES: 1,
  SECURITY_REQUEST_TYPE_REQUEST_LIST_SECURITY_TYPES: 2,
  SECURITY_REQUEST_TYPE_REQUEST_SECURITY_IDENTITY_AND_SPECIFICATIONS: 3,
  SECURITY_REQUEST_TYPE_REQUEST_SECURITY_IDENTITY_FOR_SPECIFICATIONS: 4,
  SECURITY_REQUEST_TYPE_ALL_SECURITIES: 5,
  SECURITY_REQUEST_TYPE_MARKET_ID_OR_MARKET_ID: 6,
  SECURITY_REQUEST_TYPE_PRODUCT: 7,
  SECURITY_REQUEST_TYPE_SECURITY_TYPE_AND_OR_CFI_CODE: 8,
  SECURITY_REQUEST_TYPE_SYMBOL: 9,
  SECURITY_REQUEST_TYPE_TRADING_SESSION_ID: 10
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.TradingSessionIDEnum = {
  TRADING_SESSION_ID_UNSPECIFIED: 0,
  TRADING_SESSION_ID_AFTERNOON: 1,
  TRADING_SESSION_ID_AFTER_HOURS: 2,
  TRADING_SESSION_ID_DAY: 3,
  TRADING_SESSION_ID_EVENING: 4,
  TRADING_SESSION_ID_HALF_DAY: 5,
  TRADING_SESSION_ID_MORNING: 6
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.TradingSessionSubIDEnum = {
  TRADING_SESSION_SUB_ID_UNSPECIFIED: 0,
  TRADING_SESSION_SUB_ID_CLOSING_OR_CLOSING_AUCTION: 1,
  TRADING_SESSION_SUB_ID_CONTINUOUS: 2,
  TRADING_SESSION_SUB_ID_INTRADAY_AUCTION: 3,
  TRADING_SESSION_SUB_ID_OPENING_OR_OPENING_AUCTION: 4,
  TRADING_SESSION_SUB_ID_POST_TRADING: 5,
  TRADING_SESSION_SUB_ID_PRE_TRADING: 6,
  TRADING_SESSION_SUB_ID_QUIESCENT: 7
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.ExpirationCycleEnum = {
  EXPIRATION_CYCLE_UNSPECIFIED: 0,
  EXPIRATION_CYCLE_EXPIRE_ON_TRADING_SESSION_CLOSE: 1,
  EXPIRATION_CYCLE_EXPIRE_ON_TRADING_SESSION_OPEN: 2,
  EXPIRATION_CYCLE_SPECIFIED_EXPIRATION: 3
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SubscriptionRequestTypeEnum = {
  SUBSCRIPTION_REQUEST_TYPE_UNSPECIFIED: 0,
  SUBSCRIPTION_REQUEST_TYPE_DISABLE_PREVIOUS_SNAPSHOT: 1,
  SUBSCRIPTION_REQUEST_TYPE_SNAPSHOT: 2,
  SUBSCRIPTION_REQUEST_TYPE_SNAPSHOT_AND_UPDATES: 3
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityResponseTypeEnum = {
  SECURITY_RESPONSE_TYPE_UNSPECIFIED: 0,
  SECURITY_RESPONSE_TYPE_ACCEPT_AS_IS: 1,
  SECURITY_RESPONSE_TYPE_ACCEPT_WITH_REVISIONS: 2,
  SECURITY_RESPONSE_TYPE_CANNOT_MATCH_SELECTION_CRITERIA: 3,
  SECURITY_RESPONSE_TYPE_LIST_OF_SECURITIES_RETURNED_PER_REQUEST: 4,
  SECURITY_RESPONSE_TYPE_LIST_OF_SECURITY_TYPES_RETURNED_PER_REQUEST: 5,
  SECURITY_RESPONSE_TYPE_REJECT_SECURITY_PROPOSAL: 6
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityTradingStatusEnum = {
  SECURITY_TRADING_STATUS_UNSPECIFIED: 0,
  SECURITY_TRADING_STATUS_ITSPRE_OPENING: 1,
  SECURITY_TRADING_STATUS_MARKET_IMBALANCE_BUY: 2,
  SECURITY_TRADING_STATUS_MARKET_IMBALANCE_SELL: 3,
  SECURITY_TRADING_STATUS_MARKET_ON_CLOSE_IMBALANCE_BUY: 4,
  SECURITY_TRADING_STATUS_MARKET_ON_CLOSE_IMBALANCE_SELL: 5,
  SECURITY_TRADING_STATUS_NEW_PRICE_INDICATION: 6,
  SECURITY_TRADING_STATUS_NOT_AVAILABLE_FOR_TRADING: 7,
  SECURITY_TRADING_STATUS_NOT_TRADED_ON_THIS_MARKET: 8,
  SECURITY_TRADING_STATUS_NO_MARKET_IMBALANCE: 9,
  SECURITY_TRADING_STATUS_NO_MARKET_ON_CLOSE_IMBALANCE: 10,
  SECURITY_TRADING_STATUS_NO_OPEN: 11,
  SECURITY_TRADING_STATUS_OPENING_DELAY: 12,
  SECURITY_TRADING_STATUS_PRICE_INDICATION: 13,
  SECURITY_TRADING_STATUS_READY_TO_TRADE: 14,
  SECURITY_TRADING_STATUS_RESUME: 15,
  SECURITY_TRADING_STATUS_TRADE_DISSEMINATION_TIME: 16,
  SECURITY_TRADING_STATUS_TRADING_HALT: 17,
  SECURITY_TRADING_STATUS_TRADING_RANGE_INDICATION: 18,
  SECURITY_TRADING_STATUS_UNKNOWN_OR_INVALID: 19,
  SECURITY_TRADING_STATUS_FAST_MARKET: 20,
  SECURITY_TRADING_STATUS_OPENING_ROTATION: 21,
  SECURITY_TRADING_STATUS_PRE_OPEN: 22,
  SECURITY_TRADING_STATUS_CROSS: 23,
  SECURITY_TRADING_STATUS_PRE_CROSS: 24,
  SECURITY_TRADING_STATUS_POST_CLOSE: 25
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityTradingEventEnum = {
  SECURITY_TRADING_EVENT_UNSPECIFIED: 0,
  SECURITY_TRADING_EVENT_CHANGE_OF_BOOK_TYPE: 1,
  SECURITY_TRADING_EVENT_CHANGE_OF_MARKET_DEPTH: 2,
  SECURITY_TRADING_EVENT_CHANGE_OF_SECURITY_TRADING_STATUS: 3,
  SECURITY_TRADING_EVENT_CHANGE_OF_TRADING_SESSION: 4,
  SECURITY_TRADING_EVENT_CHANGE_OF_TRADING_SUBSESSION: 5,
  SECURITY_TRADING_EVENT_ORDER_IMBALANCE: 6,
  SECURITY_TRADING_EVENT_PRICE_VOLATILITY_INTERRUPTION: 7,
  SECURITY_TRADING_EVENT_TRADING_RESUMES: 8
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.FinancialStatusEnum = {
  FINANCIAL_STATUS_UNSPECIFIED: 0,
  FINANCIAL_STATUS_BANKRUPT: 1,
  FINANCIAL_STATUS_PENDING_DELISTING: 2,
  FINANCIAL_STATUS_RESTRICTED: 3
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.HaltReasonEnum = {
  HALT_REASON_UNSPECIFIED: 0,
  HALT_REASON_ADDITIONAL_INFORMATION: 1,
  HALT_REASON_EQUIPMENT_CHANGEOVER: 2,
  HALT_REASON_NEWS_DISSEMINATION: 3,
  HALT_REASON_NEWS_PENDING: 4,
  HALT_REASON_ORDER_IMBALANCE: 5,
  HALT_REASON_ORDER_INFLUX: 6
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.MDBookTypeEnum = {
  MD_BOOK_TYPE_UNSPECIFIED: 0,
  MD_BOOK_TYPE_ORDER_DEPTH: 1,
  MD_BOOK_TYPE_PRICE_DEPTH: 2,
  MD_BOOK_TYPE_TOP_OF_BOOK: 3
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.AdjustmentEnum = {
  ADJUSTMENT_UNSPECIFIED: 0,
  ADJUSTMENT_CANCEL: 1,
  ADJUSTMENT_CORRECTION: 2,
  ADJUSTMENT_ERROR: 3
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityListRequestTypeEnum = {
  SECURITY_LIST_REQUEST_TYPE_UNSPECIFIED: 0,
  SECURITY_LIST_REQUEST_TYPE_ALL_SECURITIES: 1,
  SECURITY_LIST_REQUEST_TYPE_PRODUCT: 2,
  SECURITY_LIST_REQUEST_TYPE_SECURITY_TYPE_AND: 3,
  SECURITY_LIST_REQUEST_TYPE_SYMBOL: 4,
  SECURITY_LIST_REQUEST_TYPE_TRADING_SESSION_ID: 5,
  SECURITY_LIST_REQUEST_TYPE_MARKET_ID_OR_MARKET_ID: 6
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityListTypeEnum = {
  SECURITY_LIST_TYPE_UNSPECIFIED: 0,
  SECURITY_LIST_TYPE_INDUSTRY_CLASSIFICATION: 1,
  SECURITY_LIST_TYPE_MARKET: 2,
  SECURITY_LIST_TYPE_NEWSPAPER_LIST: 3,
  SECURITY_LIST_TYPE_TRADING_LIST: 4
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityListTypeSourceEnum = {
  SECURITY_LIST_TYPE_SOURCE_UNSPECIFIED: 0,
  SECURITY_LIST_TYPE_SOURCE_GICS: 1,
  SECURITY_LIST_TYPE_SOURCE_ICB: 2,
  SECURITY_LIST_TYPE_SOURCE_NAICS: 3
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityRequestResultEnum = {
  SECURITY_REQUEST_RESULT_UNSPECIFIED: 0,
  SECURITY_REQUEST_RESULT_INSTRUMENT_DATA_TEMPORARILY_UNAVAILABLE: 1,
  SECURITY_REQUEST_RESULT_INVALID_OR_UNSUPPORTED_REQUEST: 2,
  SECURITY_REQUEST_RESULT_NOT_AUTHORIZED_TO_RETRIEVE_INSTRUMENT_DATA: 3,
  SECURITY_REQUEST_RESULT_NO_INSTRUMENTS_FOUND: 4,
  SECURITY_REQUEST_RESULT_REQUEST_FOR_INSTRUMENT_DATA_NOT_SUPPORTED: 5,
  SECURITY_REQUEST_RESULT_VALID_REQUEST: 6
};

/**
 * @enum {number}
 */
proto.SecuritiesReferenceData.SecurityUpdateActionEnum = {
  SECURITY_UPDATE_ACTION_UNSPECIFIED: 0,
  SECURITY_UPDATE_ACTION_ADD: 1,
  SECURITY_UPDATE_ACTION_DELETE: 2,
  SECURITY_UPDATE_ACTION_MODIFY: 3
};

goog.object.extend(exports, proto.SecuritiesReferenceData);
